import { BaseInquiryToolBar, BaseNodeBar, ModuleToolBar } from "../BaseModule";
import { REFRESHICON } from "../../gui_components/Icons";
import { BarChart } from "../../gui_components/BarChart.js";
import React, { createRef, useEffect, useState } from "react";
import {
  Button,
  Col,
  FormControl,
  FormLabel,
  Row,
  Tab,
  Table,
  Tabs,
} from "react-bootstrap";
import {
  AddIcon,
  AngleDoubleLeftIcon,
  AngleDoubleRightIcon,
  BackIcon,
  ChevronLeft,
  ChevronRight,
  Eraser,
  ExcelIcon,
  ExitIcon,
  PDFIcon,
  PlayIcon,
  RefreshIcon,
  SaveIcon,
  SearchIcon,
  SwapIcon,
  TickIcon,
  UndoAlt,
} from "../../gui_components/Icons.js";
import { AppContext } from "../../AppContext.js";
import { CustomerLookupHandler } from "../../lookup/CustomerLookupHandler.js";
import { FabricStyleLookupHandler } from "../../lookup/FabricStyleLookupHandler.js";
import {
  BaseBean,
  BaseImageBean,
  ColmDef,
  NodeData,
  PageListBean,
  RestReportBean,
} from "../../ds/client_ds.js";
import {
  PopupCustomerModule,
  PopupFabricStyleModule,
  PopupInvoiceModule,
  PopupPurchaseOrderModule,
  PopupPurchaseReceiptModule,
  PopupVendorModule,
} from "../ModuleUtil.js";
import {
  CustomerSearchCriteria,
  FabricStyleDashBoardCriteriaBean,
  FabricStyleSearchCriteria,
  FabricStyleSKUBean,
  FabricStyleSoldToCustomerPrintRequest,
  RestCustomerListRequest,
  RestFabricDetailListRequest,
  RestFabricStyleListBeanRequest,
  RestPageListBean,
  RestReadRequest,
  VendorSearchCriteria,
  RestVendorListRequest,
  FabricStyleServiceDashBoardInfoBean,
  ServiceAnalysisDashBoardResultBean,
  FabricStyleDashBoardPrintRequest,
} from "../../ds/ds.js";
import {
  AlertToolBox,
  CollapseComponent,
  DatePickerComponent,
  InputTextbox,
  MultiViewPopup,
  ProgressBar,
  ShowError,
  ColumnDefinition,
} from "../../gui_components/UIComponents.js";
import {
  isEmpty,
  isEmptyArray,
  isEmptyString,
  toCommaSeperatedAmount,
} from "../../gui_components/Util.js";
import { GenericAttributeLookupHandler } from "../../lookup/GenericAttributeLookupHandler.js";
import { SecurityAccessManager } from "../../security/SecurityAccessManager.js";
import { CustomerService } from "../../services/CustomerService.js";
import { VendorService } from "../../services/VendorService.js";
import { FabricStyleService } from "../../services/FabricStyleService.js";
import { ReportService } from "../../services/ReportService.js";
import CustomTable from "../../gui_components/CustomTable.js";
import { config } from "@fortawesome/fontawesome-svg-core";
import { ConfigManager } from "../../config/ConfigManager.js";
import { VendorLookupHandler } from "../../lookup/VendorLookupHandler.js";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
// import { PieChart } from "../../gui_components/PieChart.js";
import PieChart from "../../gui_components/PieChart.js";

class ErpDashBoardForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {
      title: "ERP-EYE-DashBoard",
      isSalesTab: true,
      isPurchaseTab: false,
      isServiceTab: false,
      isInventoryTab: false,
      isShowNodes: true,
      nodeList: [],
      selectedNodeKey: "salesView",
      isLoading: false,
      salesCriteria: new FabricStyleDashBoardCriteriaBean(),
      fabricStyleInfos: [],
      customerSalesDatas: [],
      itemSalesDatas: [],
      yearlySalesDatas: [],
      lotSalesDatas: [],

      fabricStylePurchaseInfos: [],
      vendorPurchaseDatas: [],
      itemPurchaseDatas: [],
      yearlyPurchaseDatas: [],
      lotPurchaseDatas: [],
      salesPersonList: [],

      isSalesInquiryDatasFound: false,
      isPurchaseInquiryDatasFound: false,
      customerPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteCustomerList: true,
      isShowAutoCompleteFabricList: true,
      fabricPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteSalesPersonList: true,
      salesPersonPageListForAutoCompleteList: new Array(),

      isShowProgressBarPopup: false,
      progressLoadingText: "",
      inquiryData: null,
      customerSalesChart: null,
      itemSalesChart: null,
      yearlySalesChart: null,
      lotSalesChart: null,

      vendorPurchaseChart: null,
      itemPurchaseChart: null,
      yearlyPurchaseChart: null,
      lotPurchaseChart: null,

      isOpenCriteria: true,
      isShowFabricStyleModule: false,
      isShowCustomerModule: false,
      isShowInvoiceModule: false,
      isShowPOModule: false,
      isShowVendorModule: false,
      isShowReceiptModule: false,
      moduleForPopup: [],

      customerSalesInfos: [],
      fabricStyleSalesInfos: [],
      customerSummarySalesInfos: [],
      skuSalesInfos: [],

      vendorPurchaseInfos: [],
      fabricStylePurchaseInfos: [],
      customerSummaryPurchaseInfos: [],
      skuPurchaseInfos: [],

      isShowYearBox: false,
      isShowSpecificDate: false,
      yearList: [],

      vendorPageListForAutoCompleteList: new Array(),
      isShowAutoCompleteVendorList: new Array(),
      inboundCriteria: new FabricStyleServiceDashBoardInfoBean(),
      outboundCriteria: new ServiceAnalysisDashBoardResultBean(),
      isServiceInquiryDataFound: false,
      totalInBoundServiceAmount: 0,
      totalOutBoundServiceAmount: 0,
      inboundServiceList: [],
      outboundServiceList: [],

      services: [],
      serviceLookupHandler: null,
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: false,
      // is3PL: false,

      salesAnalysisCurrentPage: 1,
      salesAnalysisTotalPage: 0,

      customerSalesCurrentPage: 1,
      customerSalesTotalPage: 0,

      skuDetailsCurrentPage: 1,
      skuDetailsTotalPage: 0,

      salesTotalCurrentPage: 1,
      salesTotalPage: 0,

      customerSalesBarChartCurrentPage: 1,
      customerSalesBardChartTotalPage: 0,

      itemSalesBarChartCurrentPage: 1,
      itemSalesBardChartTotalPage: 0,

      yearlyBarChartCurrentPage: 1,
      yearlyBardChartTotalPage: 0,

      lotSalesBarChartCurrentPage: 1,
      lotSalesBardChartTotalPage: 0,

      lotSalesBarChartCurrentPage: 1,
      lotSalesBardChartTotalPage: 0,

      fabricPurchaseTotalPage: 0,
      fabricPurchaseCurrentPage: 1,

      vendorPurchaseTotalPage: 0,
      vendorPurchaseCurrentPage: 1,

      fabricVendor_PurchaseTotalPage: 0,
      fabricvendor_PurchaseCurrentPage: 1,

      vendorSummaryPurchaseTotalPage: 0,
      vendorSummaryPurchaseCurrentPage: 1,

      vendorPurchaseBarChartTotalPage: 0,
      vendorPurchaseBarChartCurrentPage: 1,

      itemPurchaseBarChartTotalPage: 0,
      itemPurchaseBarChartCurrentPage: 1,

      yearlyPurchaseBarChartTotalPage: 0,
      yearlyPurchaseBarChartCurrentPage: 1,

      lotPurchaseBarChartTotalPage: 0,
      lotPurchaseBarChartCurrentPage: 1,

      inBoundServiceTotalPage: 0,
      inBoundServiceCurrentPage: 1,

      outBoundServiceTotalPage: 0,
      outBoundServiceCurrentPage: 1,

      showAutoCompleteFabricColorList: true,
      showAutoCompleteUOMPopupList: true,
      showAutoCompleteLocationList: true,
      fabricColourPageListForAutoCompleteList: new Array(),
      locationPageListForAutoCompleteList: new Array(),
      uomPopupPageListForAutoCompleteList: new Array(),

      colorLookupHandler: null,
      warehouseLookupHandler: null,
      uomsLookupHandler: null,
      warehouses: [],
      uoms: [],
      isShowColorLookup: false,
      isInventoryInquiryDataFound: false,
      inventoryList: [],

      isShowSalesPieChart: false,
      isShowInventoryPieChart: false,

      isShowPopupAlert: false,

      salesChartType: "",
      fabricSalesPieChartInfos: [],
      customerSalesPieChartInfos: [],
      skuSalesPieChartInfos: [],
      customerSummarySalesPieChartInfos: [],
    };
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    this.report_url = appData.reportURL;
    const { cache } = appData;
    this.cache = cache;
    const attribute_cache = { ...cache };

    let services = attribute_cache.serviceInfos;
    if (services != null || services != undefined) {
      services.map((attr) => {
        this.state.services.push(attr);
      });
    }

    this.state.salesPersonList = [];
    let salesPersonList = attribute_cache.salesPersons;
    if (salesPersonList != null || salesPersonList != undefined) {
      salesPersonList.map((ent) => {
        this.state.salesPersonList.push(ent);
      });
    }

    let warehouses = attribute_cache.warehouses;
    if (warehouses != null || warehouses != undefined) {
      warehouses.map((attr) => {
        this.state.warehouses.push(attr);
      });
    }
    let uoms = attribute_cache.uoms;
    if (uoms != null || uoms != undefined) {
      uoms.map((attr) => {
        this.state.uoms.push(attr);
      });
    }

    this.getNodeList();
    this.initLookupHandlers();
    // TODO --> Loading based on node selection
    // BEFORE
    // if ((this.state.selectedNodeKey = "salesView")) this.executeSalesCustomer();

    // AFTER
    if (this.state.selectedNodeKey === "salesView") this.executeSalesCustomer();
  }
  initLookupHandlers = () => {
    let customerLookupHandler = new CustomerLookupHandler(
      this.companyCode,
      "Customer",
    );
    this.setState({ customerLookupHandler: customerLookupHandler });
    let vendorLookupHandler = new VendorLookupHandler(
      this.companyCode,
      "Vendor",
    );
    this.setState({ vendorLookupHandler: vendorLookupHandler });
    let fabricLookupHandler = new FabricStyleLookupHandler(
      this.companyCode,
      "Fabric Style",
    );
    this.setState({ fabricLookupHandler: fabricLookupHandler });

    let serviceLookupHandler = new GenericAttributeLookupHandler(
      this.state.services,
      "Service",
    );
    this.setState({ serviceLookupHandler: serviceLookupHandler });

    let salesPersonLookupHandler = new GenericAttributeLookupHandler(
      this.state.salesPersonList,
      "Sales Person",
    );
    this.setState({ salesPersonLookupHandler: salesPersonLookupHandler });

    let warehouseLookupHandler = new GenericAttributeLookupHandler(
      this.state.warehouses,
      "Warehouse",
    );
    this.setState({ warehouseLookupHandler: warehouseLookupHandler });
    let uomsLookupHandler = new GenericAttributeLookupHandler(
      this.state.uoms,
      "UOM",
    );
    this.setState({ uomsLookupHandler: uomsLookupHandler });
  };
  getEmptyView() {
    return <div></div>;
  }
  getNodeList = () => {
    let nodeList = [];
    let emptyObject = this.getEmptyView();
    let salesNode = new NodeData("salesView", "Sales", emptyObject);
    let purchaseNode = new NodeData("purchaseView", "Purchase", emptyObject);
    let serviceNode = new NodeData("serviceView", "Service", emptyObject);
    let inventoryNode = new NodeData(
      "inventoryView",
      "InventoryValuation",
      emptyObject,
    );

    nodeList["salesView"] = salesNode;
    nodeList["purchaseView"] = purchaseNode;
    if (ConfigManager.isPurchaseBasedOnCustomerFlag()) {
      nodeList["serviceView"] = serviceNode;
    }
    if (ConfigManager.isTexcoFabricKey()) {
      nodeList["inventoryView"] = inventoryNode;
    }

    this.setState({ nodeList: nodeList });
  };
  nodeOnSelect = (selectedNode) => {
    this.setState({ selectedNodeKey: selectedNode });
    if (selectedNode == "salesView") {
      this.setSalesView();
    } else if (selectedNode == "purchaseView") {
      this.setPurchaseView();
    } else if (selectedNode == "serviceView") {
      this.setServiceView();
    } else if (selectedNode == "inventoryView") {
      this.setInventoryView();
    }
  };
  closeAllNodeViews = () => {
    let criteria = new FabricStyleDashBoardCriteriaBean();
    this.setState({
      isSalesTab: true,
      isPurchaseTab: false,
      salesCriteria: criteria,
      isShowYearBox: false,
      isShowSpecificDate: false,
      isServiceTab: false,
      isInventoryTab: false,
    });
    this.state.salesCriteria = new FabricStyleDashBoardCriteriaBean();
  };
  setSalesView = () => {
    this.closeAllNodeViews();
    this.setState({
      isSalesTab: true,
      isPurchaseTab: false,
      isServiceTab: false,
      isInventoryTab: false,
    });
    this.executeSalesCustomer();
  };
  setPurchaseView = () => {
    this.closeAllNodeViews();

    this.setState({
      isSalesTab: false,
      isPurchaseTab: true,
      isServiceTab: false,
      isInventoryTab: false,
    });
  };

  setServiceView = () => {
    this.loadInboundPageList();
    this.loadOutboundPageList();
    this.closeAllNodeViews();
    this.setState({
      isSalesTab: false,
      isPurchaseTab: false,
      isServiceTab: true,
      isInventoryTab: false,
    });
  };

  setInventoryView = () => {
    this.executeInventoryList();
    this.closeAllNodeViews();
    this.setState({
      isSalesTab: false,
      isPurchaseTab: false,
      isServiceTab: false,
      isInventoryTab: true,
    });
  };

  customerCodeOnChange = (e) => {
    let customerCode = e.target.value;
    this.state.isShowAutoCompleteCustomerList = true;
    let tempCriteria = this.state.salesCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
    if (isEmpty(customerCode)) {
      this.state.isShowAutoCompleteCustomerList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteCustomerList;
      let salesCriteria = this.state.salesCriteria;
      salesCriteria.customerCode = "";
      salesCriteria.customerName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesCriteria: salesCriteria,
        customerPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "customerCode" &&
      showAutoCompleteList === true &&
      customerCode !== ""
    ) {
      this.readCustomerBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ salesCriteria: tempCriteria });
  };
  readandsetCustomerDetailResponse = (response) => {
    let salesCriteria = this.state.salesCriteria;
    if (response.data != null && response.data.customer != null) {
      let customerData = response.data.customer;
      if (!isEmpty(customerData)) {
        salesCriteria.customerName = customerData.description;
        salesCriteria.customerCode = customerData.code;
        this.setState({
          salesCriteria: salesCriteria,
        });
      }
    }
  };
  readandsetCustomerDetail = (customerCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = customerCode;
    input.isLoadChildren = true;
    CustomerService.readCustomer(
      input,
      this.readandsetCustomerDetailResponse,
      this.errorCallBack,
    );
  };
  readCustomerBySearchString(searchString) {
    let searchCriteria = new CustomerSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.customerCodeStartsWith = searchString;
    searchCriteria.customerNameContains = searchString;
    let cust_pageList = new RestPageListBean();
    cust_pageList.pageSize = 100;
    let cust_requestInput = new RestCustomerListRequest();
    cust_requestInput.pageInput = cust_pageList;
    cust_requestInput.searchCriteria = searchCriteria;
    CustomerService.getCustomerPageList(
      cust_requestInput,
      this.readByCustomerCodeResponse,
      this.errorCallBack,
    );
  }
  readByCustomerCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.customerPageList != null &&
      response.data.customerPageList.customers != null
    ) {
      let customerData = response.data.customerPageList.customers;
      let simpleAutoCompleteList = new Array();
      if (customerData.length > 0 && customerData != null) {
        customerData.map((customer) => {
          let simpleItemBean = {
            code: customer.code,
            description: customer.description,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        customerPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  customerCodeEnterKeyEventHandler = (e) => {
    let customerCode = e.target.value;
    this.readandsetCustomerDetail(customerCode);
    this.setState({
      customerPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteCustomerList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteCustomerList: showAutoCompleteList });
  };

  vendorCodeOnChange = (e) => {
    let vendorCode = e.target.value;
    let tempCriteria = this.state.salesCriteria;
    tempCriteria[e.target.name] = e.target.value;
    let isShowAutoCompleteVendorList = this.state.isShowAutoCompleteVendorList;
    this.state.isShowAutoCompleteVendorList = true;
    if (isEmpty(vendorCode)) {
      this.state.isShowAutoCompleteVendorList = false;
      let isShowAutoCompleteVendorList =
        this.state.isShowAutoCompleteVendorList;
      let salesCriteria = this.state.salesCriteria;
      salesCriteria.vendorCode = "";
      salesCriteria.vendorName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteVendorList: isShowAutoCompleteVendorList,
        salesCriteria: salesCriteria,
        vendorPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "vendorCode" &&
      isShowAutoCompleteVendorList === true &&
      vendorCode !== ""
    ) {
      this.state.isShowAutoCompleteVendorList = true;
      this.readVendorBySearchString(e.target.value);
    }

    this.setState({
      salesCriteria: tempCriteria,
    });
  };
  readandsetVendorDetailResponse = (response) => {
    let salesCriteria = this.state.salesCriteria;
    if (response.data != null && response.data.vendor != null) {
      let vendorData = response.data.vendor;
      if (!isEmpty(vendorData)) {
        salesCriteria.vendorName = vendorData.description;
        salesCriteria.vendorCode = vendorData.code;
        this.setState({
          salesCriteria: salesCriteria,
        });
      }
    }
  };
  readandsetVendorDetail = (vendorCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = vendorCode;
    input.isLoadChildren = true;
    VendorService.readVendor(
      input,
      this.readandsetVendorDetailResponse,
      this.errorCallBack,
    );
  };
  readVendorBySearchString(searchString) {
    let searchCriteria = new VendorSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.vendorCodeStartsWith = searchString;
    searchCriteria.vendorNameContains = searchString;
    let pageList = new PageListBean();
    pageList.pageSize = 100;
    let input = new RestVendorListRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    VendorService.getVendorPageList(
      input,
      this.readByVendorCodeResponse,
      this.errorCallBack,
    );
  }
  readByVendorCodeResponse = (response) => {
    let vendorCodeData = response.data.vendorPageList.vendors;
    let simpleAutoCompleteList = new Array();
    if (vendorCodeData.length > 0 && vendorCodeData != null) {
      vendorCodeData.map((vendorCode) => {
        let simpleItemBean = {
          code: vendorCode.code,
          description: vendorCode.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    this.setState({
      vendorPageListForAutoCompleteList: simpleAutoCompleteList,
    });
  };
  vendorCodeEnterKeyEventHandler = (e) => {
    let vendorCode = e.target.value;
    this.readandsetVendorDetail(vendorCode);
    this.setState({
      vendorPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteVendorList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteVendorList: showAutoCompleteList });
  };
  fabricCodeOnChange = (e) => {
    let fabricStyleCode = e.target.value;
    this.state.isShowAutoCompleteFabricList = true;
    let tempCriteria = this.state.salesCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
    if (isEmpty(fabricStyleCode)) {
      this.state.showAutoCompleteList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteFabricList;
      let salesCriteria = this.state.salesCriteria;
      salesCriteria.fabricStyleCode = "";
      salesCriteria.fabricStyleName = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteList: showAutoCompleteList,
        salesCriteria: salesCriteria,
      });
    } else if (
      e.target.name == "fabricStyleCode" &&
      showAutoCompleteList === true &&
      fabricStyleCode !== ""
    ) {
      this.readFabricBySearchString(e.target.value);
    }
    tempCriteria[e.target.name] = e.target.value;
    this.setState({ salesCriteria: tempCriteria });
  };
  readandsetFabricStyleDetailResponse = (response) => {
    let salesCriteria = this.state.salesCriteria;
    if (response.data != null && response.data.fabricStyle != null) {
      let fabricStyle = response.data.fabricStyle;
      if (!isEmpty(fabricStyle)) {
        salesCriteria.fabricStyleCode = fabricStyle.code;
        salesCriteria.fabricStyleName = fabricStyle.description;
        let colors = [];
        if (!isEmptyArray(fabricStyle.colors)) {
          colors = fabricStyle.colors;
        }
        let finalColorList = [];
        colors.map((ent) => {
          let colorBean = new BaseBean();
          colorBean.code = ent.fabricStyleColorCode;
          colorBean.description = ent.fabricStyleColorName;
          finalColorList.push(colorBean);
        });
        this.setState({ colorLookupHandler: null });
        if (finalColorList != null) {
          let colorLookupHandler = new GenericAttributeLookupHandler(
            finalColorList,
            "Color",
          );
          this.setState({
            colorLookupHandler: colorLookupHandler,
            isShowColorLookup: true,
            salesCriteria: salesCriteria,
            colorList: finalColorList,
            fabricStyleData: fabricStyle,
            isShowProgressBarPopup: false,
            progressLoadingText: "",
          });
        }
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  readandsetFabricStyleDetail = (fabricStyleCode) => {
    let input = new RestReadRequest();
    input.companyCode = this.companyCode;
    input.code = fabricStyleCode;
    input.isLoadChildren = true;
    FabricStyleService.readFabricStyle(
      input,
      this.readandsetFabricStyleDetailResponse,
      this.errorCallBack,
    );
  };
  readFabricBySearchString(searchString) {
    let searchCriteria = new FabricStyleSearchCriteria();
    searchCriteria.companyCode = this.companyCode;
    searchCriteria.fabricStyleCodeStartsWith = searchString;
    searchCriteria.fabricStyleNameStartsWith = searchString;
    let pageList = new RestPageListBean();
    pageList.pageSize = 100;
    let input = new RestFabricStyleListBeanRequest();
    input.companyCode = this.companyCode;
    input.pageInput = pageList;
    input.code = searchString;
    input.searchCriteria = searchCriteria;
    FabricStyleService.getActiveFabricStylesForAutoComplete(
      input,
      this.readByFabricCodeResponse,
      this.errorCallBack,
    );
  }
  readByFabricCodeResponse = (response) => {
    if (
      response.data != null &&
      response.data.fabricStylePageList != null &&
      response.data.fabricStylePageList.fabricStyles != null
    ) {
      let fabricStyleData = response.data.fabricStylePageList.fabricStyles;
      let simpleAutoCompleteList = new Array();
      if (fabricStyleData.length > 0 && fabricStyleData != null) {
        fabricStyleData.map((fabricStyle) => {
          let simpleItemBean = {
            code: fabricStyle.fabricStyleCode,
            description: fabricStyle.fabricStyleName,
          };
          simpleAutoCompleteList.push(simpleItemBean);
        });
      }
      this.setState({
        fabricPageListForAutoCompleteList: simpleAutoCompleteList,
      });
    }
  };
  fabricEnterKeyEventHandler = (e) => {
    this.readandsetFabricStyleDetail(e.target.value);
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: this.state.is3PL ? "read Item" : "read Fabric",
    });
    this.setState({ fabricPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteFabricList: showAutoCompleteList });
  };

  loadFabricSalesAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    if (isEmptyString(this.state.salesChartType)) {
      pageInput.pageSize = 10;
    } else {
      pageInput.pageSize = 0;
    }
    //let currentPage = {...this.state.salesAnalysisCurrentPage}
    pageInput.currentPage = this.state.salesAnalysisCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getDashBoardFabricSalesAnalysisDetails(
      criteria,
      this.loadFabricSalesAnalysisPageResponse,
      this.errorCallBack,
    );
  };
  loadFabricSalesAnalysisPageResponse = (response) => {
    let fabricStyleSalesInfos = [];
    let salesAnalysisTotalPage = this.state.salesAnalysisTotalPage;
    // let salesAnalysisCurrentPage = 0;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.fabricStyleSalesInfos)) {
        fabricStyleSalesInfos = response.data.result.fabricStyleSalesInfos;
        salesAnalysisTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    if (!isEmptyString(this.state.salesChartType)) {
      this.setState({
        fabricSalesPieChartInfos: fabricStyleSalesInfos,
        isShowSalesPieChart: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    }

    this.setState({
      fabricStyleSalesInfos: fabricStyleSalesInfos,
      salesAnalysisTotalPage: salesAnalysisTotalPage,
      //salesAnalysisCurrentPage: salesAnalysisCurrentPage,
    });
  };

  loadCustomerSalesAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    if (isEmptyString(this.state.salesChartType)) pageInput.pageSize = 10;
    else pageInput.pageSize = 0;
    pageInput.currentPage = this.state.customerSalesCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getDashBoardCustomerSalesAnalysisDetails(
      criteria,
      this.loadCustomerSalesAnalysisPageResponse,
      this.errorCallBack,
    );
  };

  loadCustomerSalesAnalysisPageResponse = (response) => {
    // console.log("loadCustomerSalesAnalysisPageResponse : #", response);
    let customerSalesInfos = [];
    let customerSalesTotalPage = this.state.customerSalesTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.customerSalesInfos)) {
        customerSalesInfos = response.data.result.customerSalesInfos;
        customerSalesTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    if (!isEmptyString(this.state.salesChartType))
      this.setState({
        customerSalesPieChartInfos: customerSalesInfos,
        isShowSalesPieChart: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    this.setState({
      customerSalesInfos: customerSalesInfos,
      customerSalesTotalPage: customerSalesTotalPage,
    });
  };

  loadFabricAndCustomerSalesAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    if (isEmptyString(this.state.salesChartType)) pageInput.pageSize = 10;
    else pageInput.pageSize = 0;
    pageInput.currentPage = this.state.skuDetailsCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getDashBoardFabricAndCustomerSalesAnalysisDetails(
      criteria,
      this.loadFabricAndCustomerSalesAnalysisPageResponse,
      this.errorCallBack,
    );
  };

  loadFabricAndCustomerSalesAnalysisPageResponse = (response) => {
    // console.log("loadFabricAndCustomerSalesAnalysisPageResponse : #", response);
    let skuSalesInfos = [];
    let skuDetailsTotalPage = this.state.skuDetailsTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.skuSalesInfos)) {
        skuSalesInfos = response.data.result.skuSalesInfos;
        skuDetailsTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    if (!isEmptyString(this.state.salesChartType))
      this.setState({
        skuSalesPieChartInfos: skuSalesInfos,
        isShowSalesPieChart: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    this.setState({
      skuSalesInfos: skuSalesInfos,
      skuDetailsTotalPage: skuDetailsTotalPage,
    });
  };

  loadCustomerSummarySalesDetail = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    if (isEmptyString(this.state.salesChartType)) pageInput.pageSize = 10;
    else pageInput.pageSize = 0;
    pageInput.currentPage = this.state.salesTotalCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getDashBoardCustomerSummarySalesDetails(
      criteria,
      this.loadCustomerSummarySalesDetailPageResponse,
      this.errorCallBack,
    );
  };

  loadCustomerSummarySalesDetailPageResponse = (response) => {
    // console.log("loadCustomerSummarySalesDetailPageResponse : #", response);
    let customerSummarySalesInfos = [];
    let salesTotalPage = this.state.salesTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.customerSummarySalesInfos)) {
        customerSummarySalesInfos =
          response.data.result.customerSummarySalesInfos;
        salesTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    if (!isEmptyString(this.state.salesChartType))
      this.setState({
        customerSummarySalesPieChartInfos: customerSummarySalesInfos,
        isShowSalesPieChart: true,
        isShowProgressBarPopup: false,
        progressLoadingText: "",
      });
    this.setState({
      customerSummarySalesInfos: customerSummarySalesInfos,
      salesTotalPage: salesTotalPage,
    });
  };

  calculateTotalPages = (totalCount, pageSize) => {
    if (!totalCount || !pageSize) {
      return 0;
    } else {
      return Math.ceil(totalCount / pageSize);
    }
  };

  executeSalesCustomer = () => {
    this.setState({
      isSalesInquiryDatasFound: true,
      salesAnalysisCurrentPage: 1,
      salesAnalysisTotalPage: 0,

      customerSalesCurrentPage: 1,
      customerSalesTotalPage: 0,

      skuDetailsCurrentPage: 1,
      skuDetailsTotalPage: 0,

      salesTotalCurrentPage: 1,
      salesTotalPage: 0,
    });
    // console.log("execute called #");
    this.customerSalesBarChart();
    this.itemSalesBarChart();
    this.yearlySalesBarChart();
    this.lotSalesBarChart();

    this.loadCustomerSalesAnalysis();
    this.loadFabricSalesAnalysis();
    this.loadFabricAndCustomerSalesAnalysis();
    this.loadCustomerSummarySalesDetail();
  };

  customerSalesBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.customerSalesBarChartCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getFabricDashBoardDetailsForCustomer(
      criteria,
      this.loadCustomerBarChartDetailPageResponse,
      this.errorCallBack,
    );
  };
  loadCustomerBarChartDetailPageResponse = (response) => {
    console.log("loadCustomerBarChartDetailPageResponse #", response); // uncomment this line for debugging and remove before production 05-03-2026
    let inquiryDataList = response.data.result;
    let customerSalesDataList = [];
    let fabricStyleInfos = [];
    let customerSalesChart = this.state.customerSalesChart;

    let customerSalesBardChartTotalPage =
      this.state.customerSalesBardChartTotalPage;
    if (customerSalesChart != null) customerSalesChart.length = 0;

    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.customerSalesData)) {
        customerSalesDataList = response.data.result.customerSalesData;
        customerSalesChart = this.customerSalesChartData(customerSalesDataList);
      }
      customerSalesBardChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      // inquiryData: inquiryDataList,
      customerSalesDatas: customerSalesDataList,
      fabricStyleInfos: fabricStyleInfos,
      customerSalesChart: customerSalesChart,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      customerSalesBardChartTotalPage: customerSalesBardChartTotalPage,
    });
  };

  itemSalesBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.itemSalesBarChartCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getFabricDashBoardDetails(
      criteria,
      this.loadItemSalesBarChartPageResponse,
      this.errorCallBack,
    );
  };

  loadItemSalesBarChartPageResponse = (response) => {
    console.log("loadItemSalesBarChartPageResponse #", response);
    let inquiryDataList = response.data.result;
    let customerSalesDataList = [];
    let itemSalesDataList = [];
    let fabricStyleInfos = [];
    let itemSalesChart = this.state.itemSalesChart;

    let itemSalesBardChartTotalPage = this.state.itemSalesBardChartTotalPage;
    if (itemSalesChart != null) itemSalesChart.length = 0;

    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
        customerSalesDataList = response.data.result.fabricStyleInfos;
        fabricStyleInfos = response.data.result.fabricStyleInfos;
      }
      if (!isEmptyArray(response.data.result.itemSalesData)) {
        itemSalesDataList = response.data.result.itemSalesData;
        itemSalesChart = this.itemSalesChartData(itemSalesDataList);
      }
      itemSalesBardChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      inquiryData: inquiryDataList,
      customerSalesDatas: customerSalesDataList,
      fabricStyleInfos: fabricStyleInfos,
      itemSalesDatas: itemSalesDataList,
      itemSalesChart: itemSalesChart,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      itemSalesBardChartTotalPage: itemSalesBardChartTotalPage,
    });
  };

  yearlySalesBarChart = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.itemSalesBarChartCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getFabricDashBoardDetailsForYear(
      criteria,
      this.loadFabricDashboardDetailForYearPageResponse,
      this.errorCallBack,
    );
  };

  loadFabricDashboardDetailForYearPageResponse = (response) => {
    // console.log("loadFabricDashboardDetailForYearPageResponse #", response);
    let inquiryDataList = response.data.result;
    let yearlySalesDataList = [];
    let yearlySalesChart = this.state.yearlySalesChart;
    let yearlyBardChartTotalPage = this.state.yearlyBardChartTotalPage;

    if (yearlySalesChart != null) yearlySalesChart.length = 0;

    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.yearlySalesData)) {
        yearlySalesDataList = response.data.result.yearlySalesData;
        yearlySalesChart = this.yearlySalesChartData(yearlySalesDataList);
      }
      yearlyBardChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      // inquiryData: inquiryDataList,
      yearlySalesDatas: yearlySalesDataList,
      yearlySalesChart: yearlySalesChart,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      yearlyBardChartTotalPage: yearlyBardChartTotalPage,
    });
  };

  lotSalesBarChart = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.lotSalesBarChartCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getFabricDashBoardDetailsForLotNumber(
      criteria,
      this.loadFabricDashboardDetailLotNumberPageResponse,
      this.errorCallBack,
    );
  };

  loadFabricDashboardDetailLotNumberPageResponse = (response) => {
    let inquiryDataList = response.data.result;
    let lotSalesDataList = [];
    let lotSalesChart = this.state.lotSalesChart;

    let lotSalesBardChartTotalPage = this.state.lotSalesBardChartTotalPage;
    if (lotSalesChart != null) lotSalesChart.length = 0;

    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.lotSalesData)) {
        lotSalesDataList = response.data.result.lotSalesData;
        lotSalesChart = this.lotSalesChartData(lotSalesDataList);
        lotSalesBardChartTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    this.setState({
      // inquiryData: inquiryDataList,
      lotSalesDatas: lotSalesDataList,
      lotSalesChart: lotSalesChart,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      lotSalesBardChartTotalPage: lotSalesBardChartTotalPage,
    });
  };

  loadFabricPurchaseAnalysisPageResponse = (response) => {
    console.log("loadFabricPurchaseAnalysisPageResponse #", response);

    let fabricStylePurchaseInfos = [];
    let fabricPurchaseTotalPage = this.state.fabricPurchaseTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.fabricStylePurchaseInfos)) {
        fabricStylePurchaseInfos =
          response.data.result.fabricStylePurchaseInfos;

        fabricPurchaseTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    this.setState({
      fabricStylePurchaseInfos: fabricStylePurchaseInfos,
      fabricPurchaseTotalPage: fabricPurchaseTotalPage,
      // inquiryData: inquiryDataList,
    });
  };
  loadFabricPurchaseAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.fabricPurchaseCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getDashBoardFabricPurchaseAnalysisDetails(
      criteria,
      this.loadFabricPurchaseAnalysisPageResponse,
      this.errorCallBack,
    );
  };
  loadVendorPurchaseAnalysisPageResponse = (response) => {
    let vendorPurchaseInfos = [];
    let inquiryDataList = response.data.result;
    let vendorPurchaseTotalPage = this.state.vendorPurchaseTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.vendorPurchaseInfos)) {
        vendorPurchaseInfos = response.data.result.vendorPurchaseInfos;
        vendorPurchaseTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    this.setState({
      vendorPurchaseInfos: vendorPurchaseInfos,
      vendorPurchaseTotalPage: vendorPurchaseTotalPage,
      // inquiryData: inquiryDataList,
    });
  };
  loadVendorPurchaseAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.vendorPurchaseCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getDashBoardVendorPurchaseAnalysisDetails(
      criteria,
      this.loadVendorPurchaseAnalysisPageResponse,
      this.errorCallBack,
    );
  };
  loadFabricAndVendorPurchaseAnalysisPageResponse = (response) => {
    let skuPurchaseInfos = [];
    let fabricVendor_PurchaseTotalPage =
      this.state.fabricVendor_PurchaseTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.skuPurchaseInfos)) {
        skuPurchaseInfos = response.data.result.skuPurchaseInfos;
        fabricVendor_PurchaseTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    this.setState({
      skuPurchaseInfos: skuPurchaseInfos,
      fabricVendor_PurchaseTotalPage: fabricVendor_PurchaseTotalPage,
    });
  };
  loadFabricAndVendorPurchaseAnalysis = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.fabricvendor_PurchaseCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getDashBoardFabricAndVendorPurchaseAnalysisDetails(
      criteria,
      this.loadFabricAndVendorPurchaseAnalysisPageResponse,
      this.errorCallBack,
    );
  };
  loadVendorSummaryPurchaseDetailPageResponse = (response) => {
    let vendorSummaryPurchaseInfos = [];
    let vendorSummaryPurchaseTotalPage =
      this.state.vendorSummaryPurchaseTotalPage;
    if (!isEmpty(response.data) && !isEmpty(response.data.result)) {
      if (!isEmptyArray(response.data.result.vendorSummaryPurchaseInfos)) {
        vendorSummaryPurchaseInfos =
          response.data.result.vendorSummaryPurchaseInfos;
        vendorSummaryPurchaseTotalPage = this.calculateTotalPages(
          response.data.result.totalCount,
          response.data.result.pageSize,
        );
      }
    }
    this.setState({
      vendorSummaryPurchaseInfos: vendorSummaryPurchaseInfos,
      vendorSummaryPurchaseTotalPage: vendorSummaryPurchaseTotalPage,
    });
  };
  loadVendorSummaryPurchaseDetail = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.vendorSummaryPurchaseCurrentPage;
    criteria.pageList = pageInput;
    ReportService.getDashBoardVendorSummaryPurchaseDetails(
      criteria,
      this.loadVendorSummaryPurchaseDetailPageResponse,
      this.errorCallBack,
    );
  };

  executePurchaseVendor = () => {
    this.setState({
      isPurchaseInquiryDatasFound: true,
      fabricPurchaseTotalPage: 0,
      fabricPurchaseCurrentPage: 1,

      vendorPurchaseTotalPage: 0,
      vendorPurchaseCurrentPage: 1,

      fabricVendor_PurchaseTotalPage: 0,
      fabricvendor_PurchaseCurrentPage: 1,

      vendorSummaryPurchaseTotalPage: 0,
      vendorSummaryPurchaseCurrentPage: 1,

      vendorPurchaseBarChartTotalPage: 0,
      vendorPurchaseBarChartCurrentPage: 1,

      itemPurchaseBarChartTotalPage: 0,
      itemPurchaseBarChartCurrentPage: 1,

      yearlyPurchaseBarChartTotalPage: 0,
      yearlyPurchaseBarChartCurrentPage: 1,

      lotPurchaseBarChartTotalPage: 0,
      lotPurchaseBarChartCurrentPage: 1,
    });

    this.loadVendorPurchaseBarChart();
    this.loadItemPurchaseBarChart();
    this.loadYearlyPurchaseBarChart();
    this.loadLotPurchaseBarChart();

    this.loadVendorPurchaseAnalysis();
    this.loadFabricPurchaseAnalysis();
    this.loadFabricAndVendorPurchaseAnalysis();
    this.loadVendorSummaryPurchaseDetail();
  };

  loadVendorPurchaseBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    criteria.detailsMode = 1;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.vendorPurchaseBarChartCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getFabricDashBoardPurchaseDetails(
      criteria,
      this.loadVendorPurchaseBarChartPageResponse,
      this.errorCallBack,
    );
  };
  // loadVendorPurchaseBarChartPageResponse = (response) => {
  //   let inquiryDataList = response.data.result;
  //   let vendorPurchaseDataList = [];
  //   let fabricStylePurchaseInfos = [];
  //   let vendorPurchaseChart = this.state.vendorPurchaseChart;
  //   let vendorPurchaseBarChartTotalPage =
  //     this.state.vendorPurchaseBarChartTotalPage;
  //   if (vendorPurchaseChart != null) vendorPurchaseChart.length = 0;
  //   if (response.data != null && response.data.result != null) {
  //     if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
  //       fabricStylePurchaseInfos = response.data.result.fabricStyleInfos;
  //     }
  //     if (!isEmptyArray(response.data.result.vendorPurchaseData)) {
  //       vendorPurchaseDataList = response.data.result.vendorPurchaseData;
  //       vendorPurchaseChart = this.vendorPurchaseChartData(
  //         vendorPurchaseDataList,
  //       );
  //     }
  //     vendorPurchaseBarChartTotalPage = this.calculateTotalPages(
  //       response.data.result.totalCount,
  //       response.data.result.pageSize,
  //     );
  //   }
  //   this.setState({
  //     fabricStylePurchaseInfos: fabricStylePurchaseInfos,
  //     vendorPurchaseDatas: vendorPurchaseDataList,

  //     isLoading: false,
  //     isShowProgressBarPopup: false,
  //     progressLoadingText: "",
  //     vendorPurchaseChart: vendorPurchaseChart,
  //     vendorPurchaseBarChartTotalPage: vendorPurchaseBarChartTotalPage,
  //   });
  // };

  // console.log("loadVendorPurchaseBarChartPageResponse #", response); // uncomment this line for debugging
  // commented for  OVERWRITES & collides with table data
  // AFTER
  loadVendorPurchaseBarChartPageResponse = (response) => {
    let vendorPurchaseDataList = [];
    let vendorPurchaseChart = this.state.vendorPurchaseChart;
    let vendorPurchaseBarChartTotalPage =
      this.state.vendorPurchaseBarChartTotalPage;

    if (vendorPurchaseChart != null) vendorPurchaseChart.length = 0;
    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.vendorPurchaseData)) {
        vendorPurchaseDataList = response.data.result.vendorPurchaseData;
        vendorPurchaseChart = this.vendorPurchaseChartData(
          vendorPurchaseDataList,
        );
      }
      vendorPurchaseBarChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      vendorPurchaseDatas: vendorPurchaseDataList,
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      vendorPurchaseChart: vendorPurchaseChart,
      vendorPurchaseBarChartTotalPage: vendorPurchaseBarChartTotalPage,
    });
  };

  loadItemPurchaseBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    criteria.detailsMode = 0;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.itemPurchaseBarChartCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getFabricDashBoardPurchaseDetails(
      criteria,
      this.loadItemPurchaseBarChartPageResponse,
      this.errorCallBack,
    );
  };
  // loadItemPurchaseBarChartPageResponse = (response) => {
  //   console.log("loadItemPurchaseBarChartPageResponse #", response);
  //   let itemPurchaseDataList = [];
  //   let itemPurchaseChart = this.state.itemPurchaseChart;
  //   let itemPurchaseBarChartTotalPage =
  //     this.state.itemPurchaseBarChartTotalPage;
  //   let fabricStylePurchaseInfos = [];
  //   let inquiryData = null;
  //   if (itemPurchaseChart != null) itemPurchaseChart.length = 0;
  //   if (response.data != null && response.data.result != null) {
  //     inquiryData = response.data.result;
  //     if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
  //       fabricStylePurchaseInfos = response.data.result.fabricStyleInfos;
  //     }
  //     if (!isEmptyArray(response.data.result.itemPurchaseData)) {
  //       itemPurchaseDataList = response.data.result.itemPurchaseData;
  //       itemPurchaseChart = this.itemPurchaseChartData(itemPurchaseDataList);
  //     }
  //     itemPurchaseBarChartTotalPage = this.calculateTotalPages(
  //       response.data.result.totalCount,
  //       response.data.result.pageSize,
  //     );
  //   }
  //   this.setState({
  //     inquiryData: inquiryData,
  //     itemPurchaseDatas: itemPurchaseDataList,
  //     isLoading: false,
  //     isShowProgressBarPopup: false,
  //     progressLoadingText: "",
  //     itemPurchaseChart: itemPurchaseChart,
  //     itemPurchaseBarChartTotalPage: itemPurchaseBarChartTotalPage,
  //     fabricStylePurchaseInfos: fabricStylePurchaseInfos,
  //   });
  // };

  // AFTER
  loadItemPurchaseBarChartPageResponse = (response) => {
    let itemPurchaseDataList = [];
    let itemPurchaseChart = this.state.itemPurchaseChart;
    let itemPurchaseBarChartTotalPage =
      this.state.itemPurchaseBarChartTotalPage;
    let inquiryData = null;

    if (itemPurchaseChart != null) itemPurchaseChart.length = 0;
    if (response.data != null && response.data.result != null) {
      inquiryData = response.data.result;
      if (!isEmptyArray(response.data.result.itemPurchaseData)) {
        itemPurchaseDataList = response.data.result.itemPurchaseData;
        itemPurchaseChart = this.itemPurchaseChartData(itemPurchaseDataList);
      }
      itemPurchaseBarChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      inquiryData: inquiryData,
      itemPurchaseDatas: itemPurchaseDataList,
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      itemPurchaseChart: itemPurchaseChart,
      itemPurchaseBarChartTotalPage: itemPurchaseBarChartTotalPage,
    });
  };

  loadYearlyPurchaseBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    criteria.detailsMode = 4;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.yearlyPurchaseBarChartCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getFabricDashBoardPurchaseDetails(
      criteria,
      this.loadYearlyPurchaseBarChartPageResponse,
      this.errorCallBack,
    );
  };
  loadYearlyPurchaseBarChartPageResponse = (response) => {
    let yearlyPurchaseDataList = [];
    let yearlyPurchaseChart = this.state.yearlyPurchaseChart;
    let yearlyPurchaseBarChartTotalPage =
      this.state.yearlyPurchaseBarChartTotalPage;
    let fabricStylePurchaseInfos = [];
    if (yearlyPurchaseChart != null) yearlyPurchaseChart.length = 0;
    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
        fabricStylePurchaseInfos = response.data.result.fabricStyleInfos;
      }
      if (!isEmptyArray(response.data.result.yearlyPurchaseData)) {
        yearlyPurchaseDataList = response.data.result.yearlyPurchaseData;
        yearlyPurchaseChart = this.yearlyPurchaseChartData(
          yearlyPurchaseDataList,
        );
      }
      yearlyPurchaseBarChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      yearlyPurchaseDatas: yearlyPurchaseDataList,
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      yearlyPurchaseChart: yearlyPurchaseChart,
      yearlyPurchaseBarChartTotalPage: yearlyPurchaseBarChartTotalPage,
    });
  };

  loadLotPurchaseBarChart = () => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    criteria.detailsMode = 3;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.lotPurchaseBarChartCurrentPage;
    criteria.pageList = pageInput;

    ReportService.getFabricDashBoardPurchaseDetails(
      criteria,
      this.loadLotPurchaseBarChartPageResponse,
      this.errorCallBack,
    );
  };
  loadLotPurchaseBarChartPageResponse = (response) => {
    console.log("loadLotPurchaseBarChartPageResponse #", response);
    let lotPurchaseDataList = [];
    let lotPurchaseChart = this.state.lotPurchaseChart;
    let lotPurchaseBarChartTotalPage = this.state.lotPurchaseBarChartTotalPage;
    let fabricStylePurchaseInfos = [];
    if (lotPurchaseChart != null) lotPurchaseChart.length = 0;
    if (response.data != null && response.data.result != null) {
      if (!isEmptyArray(response.data.result.fabricStyleInfos)) {
        fabricStylePurchaseInfos = response.data.result.fabricStyleInfos;
      }
      if (!isEmptyArray(response.data.result.lotPurchaseData)) {
        lotPurchaseDataList = response.data.result.lotPurchaseData;
        lotPurchaseChart = this.lotPurchaseChartData(lotPurchaseDataList);
      }
      lotPurchaseBarChartTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      lotPurchaseDatas: lotPurchaseDataList,
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      lotPurchaseChart: lotPurchaseChart,
      lotPurchaseBarChartTotalPage: lotPurchaseBarChartTotalPage,
    });
  };

  disable = () => {
    this.setState({
      isDisableFields: true,
    });
  };
  errorCallBack = (error) => {
    ShowError(error);
    this.setState({
      isLoading: false,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };
  salesOnChange = (e) => {
    let criteria = this.state.salesCriteria;
    criteria[e.target.name] = e.target.value;
    if (e.target.name == "dateMode") {
      if (e.target.value == 2) {
        this.setState({ isShowYearBox: true, isShowSpecificDate: false });
        const currentYear = new Date().getFullYear();
        criteria.year = currentYear;
        const yearList = new Array(5)
          .fill(currentYear)
          .map((year, i) => year - i)
          .map((year) => year.toString())
          .map((stringifiedYear) => ({ year: stringifiedYear }));
        this.setState({ yearList: yearList });
      } else if (e.target.value == 3) {
        this.setState({ isShowSpecificDate: true, isShowYearBox: false });
      } else {
        this.setState({ isShowSpecificDate: false, isShowYearBox: false });
      }
    }
    this.setState({ salesCriteria: criteria });
  };
  resetSalesCustomer = () => {
    let tempCriteria = new FabricStyleDashBoardCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    tempCriteria.customerName = "";
    tempCriteria.productDivision = "";
    tempCriteria.salesPersonName = "";
    this.setState({
      isDisableFields: false,
      salesCriteria: tempCriteria,
      isShowYearBox: false,
      isShowSpecificDate: false,
    });
    this.state.salesCriteria = tempCriteria;
    this.executeSalesCustomer();
  };

  purchaseOnChange = (e) => {
    let criteria = this.state.salesCriteria;
    criteria[e.target.name] = e.target.value;
    if (e.target.name == "dateMode") {
      if (e.target.value == 2) {
        this.setState({ isShowYearBox: true, isShowSpecificDate: false });
        const currentYear = new Date().getFullYear();
        const yearList = new Array(5)
          .fill(currentYear)
          .map((year, i) => year - i)
          .map((year) => year.toString())
          .map((stringifiedYear) => ({ year: stringifiedYear }));
        this.setState({ yearList: yearList });
      } else if (e.target.value == 3) {
        this.setState({ isShowSpecificDate: true, isShowYearBox: false });
      } else {
        this.setState({ isShowSpecificDate: false, isShowYearBox: false });
      }
    }
    this.setState({ salesCriteria: criteria });
  };
  resetPurchaseVendor = () => {
    let tempCriteria = new FabricStyleDashBoardCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    tempCriteria.vendorName = "";
    this.setState({
      isDisableFields: false,
      salesCriteria: tempCriteria,
      isShowYearBox: false,
      isShowSpecificDate: false,
    });
    this.state.salesCriteria = tempCriteria;
    this.executePurchaseVendor();
  };

  customerSalesChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: val.name,
        });
      }

      return acc;
    }, []);
  };

  itemSalesChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: val.name,
        });
      }
      return acc;
    }, []);
  };
  yearlySalesChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }
      return acc;
    }, []);
  };
  lotSalesChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }
      return acc;
    }, []);
  };

  vendorPurchaseChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }

      return acc;
    }, []);
  };

  itemPurchaseChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }
      return acc;
    }, []);
  };
  yearlyPurchaseChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }
      return acc;
    }, []);
  };
  lotPurchaseChartData = (arr) => {
    return arr.reduce((acc, val) => {
      const index = acc.findIndex((obj) => obj.category === val.category);
      if (index !== -1) {
        acc[index].value += val.value;
      } else {
        acc.push({
          category: val.category,
          value: val.value,
          name: "",
        });
      }
      return acc;
    }, []);
  };

  closeNav = () => {
    if (this.state.isOpenCriteria) this.setState({ isOpenCriteria: false });
    else this.setState({ isOpenCriteria: true });
  };
  closeModalCallBack = (isOpen) => {
    this.setState({
      isShowFabricStyleModule: isOpen,
      isShowCustomerModule: isOpen,
      isShowInvoiceModule: isOpen,
      isShowPOModule: isOpen,
      isShowVendorModule: isOpen,
      isShowReceiptModule: isOpen,
      moduleForPopup: [],
    });
  };
  onPopupModalExit = () => {
    this.closeModalCallBack(false);
  };
  viewInvoiceModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowInvoiceModule: true,
          moduleForPopup: (
            <PopupInvoiceModule
              invoiceCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewFabricModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowFabricStyleModule: true,
          moduleForPopup: (
            <PopupFabricStyleModule
              fabricStyleCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewCustomerModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowCustomerModule: true,
          moduleForPopup: (
            <PopupCustomerModule
              customerCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewVendorModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowVendorModule: true,
          moduleForPopup: (
            <PopupVendorModule
              vendorCode={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPOModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowPOModule: true,
          moduleForPopup: (
            <PopupPurchaseOrderModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  viewPRModule = (e, code, rowData) => {
    if (e.detail === 1) {
      if (code !== "" && code !== undefined) {
        this.setState({
          isShowReceiptModule: true,
          moduleForPopup: (
            <PopupPurchaseReceiptModule
              code={code}
              onModuleExit={this.onPopupModalExit}
            />
          ),
        });
      }
    }
  };
  yearClickHandler = () => {
    this.setState({
      isShowYearBox: true,
    });
  };

  //setServiceVendor

  loadInboundPageList = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.inBoundServiceCurrentPage;
    criteria.pageList = pageInput;
    //  if (SecurityAccessManager.CustomerSalesDetailsInquiry_IsAccessible()) {
    ReportService.getDashBoardInBoundDetails(
      criteria,
      this.loadInboundPagePageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadOutboundPageList = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let pageInput = new PageListBean();
    pageInput.pageSize = 10;
    pageInput.currentPage = this.state.outBoundServiceCurrentPage;
    criteria.pageList = pageInput;
    //  if (SecurityAccessManager.CustomerSalesDetailsInquiry_IsAccessible()) {
    ReportService.getDashBoardOutBoundDetails(
      criteria,
      this.loadOutBoundPageResponse,
      this.errorCallBack,
    );
    // } else {
    //   this.inValidAccess(1);
    // }
  };
  loadInboundPagePageResponse = (response) => {
    let totalInBoundServiceAmount = 0;
    let isServiceInquiryDataFound = false;
    let inboundServiceList = [];
    let inBoundServiceTotalPage = this.state.inBoundServiceTotalPage;
    if (response.data != null && response.data.result != null) {
      isServiceInquiryDataFound = true;
      totalInBoundServiceAmount =
        response.data.result.totalInBoundServiceAmount;
      if (!isEmptyArray(response.data.result.inBoundInfos)) {
        inboundServiceList = response.data.result.inBoundInfos;
      }
      inBoundServiceTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      isServiceInquiryDataFound: isServiceInquiryDataFound,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      totalInBoundServiceAmount: totalInBoundServiceAmount,
      inboundServiceList: inboundServiceList,
      inBoundServiceTotalPage: inBoundServiceTotalPage,
    });
  };
  loadOutBoundPageResponse = (response) => {
    let totalOutBoundServiceAmount = 0;
    let outboundServiceList = [];
    let outBoundServiceTotalPage = this.state.outBoundServiceTotalPage;
    if (response.data != null && response.data.result != null) {
      totalOutBoundServiceAmount =
        response.data.result.totalOutBoundServiceAmount;
      if (!isEmptyArray(response.data.result.outBoundInfos)) {
        outboundServiceList = response.data.result.outBoundInfos;
      }
      outBoundServiceTotalPage = this.calculateTotalPages(
        response.data.result.totalCount,
        response.data.result.pageSize,
      );
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      outboundServiceList: outboundServiceList,
      totalOutBoundServiceAmount: totalOutBoundServiceAmount,
      outBoundServiceTotalPage: outBoundServiceTotalPage,
    });
  };
  executeServiceList = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadInboundPageList();
    this.loadOutboundPageList();
  };
  resetServiceList = () => {
    let tempCriteria = new FabricStyleDashBoardCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.customerName = "";
    tempCriteria.serviceName = "";
    this.setState({
      isDisableFields: false,
      salesCriteria: tempCriteria,
      isShowYearBox: false,
      isShowSpecificDate: false,
    });
    this.state.salesCriteria = tempCriteria;
    this.executeServiceList();
  };

  salesPersonCodeOnChange = (e) => {
    let salesPersonCode = e.target.value;
    this.state.isShowAutoCompleteSalesPersonList = true;
    let temp_criteria = this.state.salesCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteSalesPersonList;
    if (isEmpty(salesPersonCode)) {
      this.state.isShowAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteSalesPersonList;
      temp_criteria.salesPersonCode = "";
      temp_criteria.salesPersonName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteSalesPersonList: showAutoCompleteList,
        salesCriteria: temp_criteria,
        salesPersonPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && salesPersonCode !== "") {
      this.readSalesPersonBySearchString(salesPersonCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ criteria: temp_criteria });
    this.readSalesPerson(salesPersonCode);
  };

  readSalesPerson = (salesPersonCode) => {
    let salesPersonBean = null;
    this.state.salesPersonList.map((ln) => {
      if (ln.code === salesPersonCode) {
        salesPersonBean = ln;
      }
    });
    if (!isEmpty(salesPersonBean)) {
      let temp_criteria = this.state.salesCriteria;
      temp_criteria.salesPersonCode = salesPersonBean.code;
      temp_criteria.salesPersonName = salesPersonBean.description;
      this.state.isShowAutoCompleteSalesPersonList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteSalesPersonList;
      this.setState({
        salesCriteria: temp_criteria,
        isShowAutoCompleteSalesPersonList: showAutoCompleteList,
      });
    }
  };
  readSalesPersonBySearchString = (searchString) => {
    let salesPersonData = this.state.salesPersonList;
    let simpleAutoCompleteList = new Array();
    if (salesPersonData.length > 0 && salesPersonData != null) {
      salesPersonData.map((sp) => {
        let salesPersonBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(salesPersonBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      salesPersonPageListForAutoCompleteList: filteredSuggestions,
    });
  };
  salesPersonEnterKeyEventHandler = (e) => {
    let salesPersonCode = e.target.value;
    this.readSalesPerson(salesPersonCode);
    this.setState({
      salesPersonPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteSalesPersonList = (showAutoCompleteList) => {
    this.setState({ isShowAutoCompleteSalesPersonList: showAutoCompleteList });
  };

  fabricSalesExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricSalesReport(2);
  };

  generateFabricSalesReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;
    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardFabricSalesInfoPrintReport(
        listRequest,
        this.generateDashBoardFabricSalesInfoPrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardFabricSalesInfoPrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //Customer Sales Infos
  customerSalesExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateCustomerSalesReport(2);
  };

  generateCustomerSalesReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardCustomerSalesInfoPrintReport(
        listRequest,
        this.generateDashBoardCustomerSalesInfoPrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardCustomerSalesInfoPrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //SKU Details Report
  skuDetailExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateSkuDetailsReport(2);
  };
  generateSkuDetailsReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardSalesSkuDetailsPrintReport(
        listRequest,
        this.generateDashBoardSkuDetailsPrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardSkuDetailsPrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //Total Sales Report
  customerSummaryExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateTotalSalesReport(2);
  };
  generateTotalSalesReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardTotalSalesPrintReport(
        listRequest,
        this.generateDashBoardTotalSalesPrintPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardTotalSalesPrintPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //Fabric Purchase Infos
  fabricPurchaseInfoexcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateFabricPurchaseReport(2);
  };
  generateFabricPurchaseReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardFabricPurchaseDetailsPrintReport(
        listRequest,
        this.generateDashBoardFabricPurchaseDetailsPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardFabricPurchaseDetailsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //Vendor Purchase Infos

  vendorPurchaseInfoExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generateVendorPurchaseInfoReport(2);
  };
  generateVendorPurchaseInfoReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardVendorPurchaseInfoPrintReport(
        listRequest,
        this.generateDashBoardVendorPurchaseDetailsPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardVendorPurchaseDetailsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //SKU Details Report

  skuDetailPOExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generatePurchaseSkuDetailReport(2);
  };
  generatePurchaseSkuDetailReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardPurchaseSkuDetailsPrintReport(
        listRequest,
        this.generateDashBoardPurchaseSkuDetailsPageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardPurchaseSkuDetailsPageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  //Total Purchase Report
  vendorSummaryPOExcelHandler = (e) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Generating ...",
    });
    this.generatePurchaseVendorSummaryReport(2);
  };
  generatePurchaseVendorSummaryReport = (reportType) => {
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;
    let reportBean = new RestReportBean();
    reportBean.reportType = reportType;
    let listRequest = new FabricStyleDashBoardPrintRequest();
    listRequest.criteria = criteria;
    listRequest.reportBean = reportBean;

    if (reportBean.reportType == 2) {
      ReportService.generateDashBoardTotalPurchasePrintReport(
        listRequest,
        this.generateDashBoardTotalPurchasePageResponse,
        this.errorCallBack,
      );
    } else {
      this.inValidAccess(3);
    }
  };

  generateDashBoardTotalPurchasePageResponse = (response) => {
    this.showErrorMessage(response.data);
    if (response.data != null && response.data.reportResult != null) {
      if (!isEmptyString(response.data.reportResult.reportFileID)) {
        let reportFilePath = response.data.reportResult.reportFileID;
        window.open(this.report_url + reportFilePath);
      }
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  inValidAccess = (type) => {
    let errMsg = "Access Denied";
    if (type == 1) {
      errMsg = "Access Denied";
    } else if (type == 2) {
      errMsg = "PDF Access Denied";
    } else if (type == 3) {
      errMsg = "EXCEL Access Denied";
    } else if (type == 4) {
      errMsg = "Mail Access Denied";
    }
    let errList = [];
    errList.push(errMsg);
    this.setState({
      alertMessage: errList,
      alertType: "danger",
      isShowAlert: true,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  showErrorMessage = (response) => {
    if (response.errors != null) {
      let errMsg = "";
      let errList = [];
      response.errors.map(
        (err) => (
          (errMsg = errMsg + err.messageDescription),
          errList.push(err.messageDescription)
        ),
      );
      this.setState({ error_list: errList });
      this.setState({
        alertMessage: errList,
        alertType: "danger",
        isShowAlert: true,
      });
    }
    this.setState({
      isShowProgressBarPopup: false,
      progressLoadingText: "",
    });
  };

  getSalesView() {
    return (
      <SalesViewForm
        {...this.state}
        customerCodeOnChange={this.customerCodeOnChange}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        fabricCodeOnChange={this.fabricCodeOnChange}
        fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
        displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        executeSalesCustomer={this.executeSalesCustomer}
        salesOnChange={this.salesOnChange}
        resetSalesCustomer={this.resetSalesCustomer}
        closeNav={this.closeNav}
        viewCustomerModule={this.viewCustomerModule}
        viewFabricModule={this.viewFabricModule}
        viewInvoiceModule={this.viewInvoiceModule}
        yearClickHandler={this.yearClickHandler}
        salesPersonCodeOnChange={this.salesPersonCodeOnChange}
        salesPersonEnterKeyEventHandler={this.salesPersonEnterKeyEventHandler}
        displayAutoCompleteSalesPersonList={
          this.displayAutoCompleteSalesPersonList
        }
        fabricSalesExcelHandler={this.fabricSalesExcelHandler}
        customerSalesExcelHandler={this.customerSalesExcelHandler}
        skuDetailExcelHandler={this.skuDetailExcelHandler}
        customerSummaryExcelHandler={this.customerSummaryExcelHandler}
        loadSalesAnalysisFirst={this.loadSalesAnalysisFirst}
        loadSalesAnalysisPrevious={this.loadSalesAnalysisPrevious}
        loadSalesAnalysisNext={this.loadSalesAnalysisNext}
        loadSalesAnalysisLast={this.loadSalesAnalysisLast}
        salesInfosOnChange={this.salesInfosOnChange}
        salesInfosOnBlur={this.salesInfosOnBlur}
        handleCustomerSalesBardChartPageClick={
          this.handleCustomerSalesBardChartPageClick
        }
        loadCustomerSalesFirst={this.loadCustomerSalesFirst}
        loadCustomerSalesPrevious={this.loadCustomerSalesPrevious}
        loadCustomerSalesNext={this.loadCustomerSalesNext}
        loadCustomerSalesLast={this.loadCustomerSalesLast}
        customerSalesOnChange={this.customerSalesOnChange}
        customerSalesOnBlur={this.customerSalesOnBlur}
        customerSalesOnClick={this.customerSalesOnClick}
        loadSkuDetailFirst={this.loadSkuDetailFirst}
        loadSkuDetailPrevious={this.loadSkuDetailPrevious}
        loadSkuDetailNext={this.loadSkuDetailNext}
        loadSkuDetailLast={this.loadSkuDetailLast}
        skuDetailsOnChange={this.skuDetailsOnChange}
        skuDetailsSalesOnBlur={this.skuDetailsSalesOnBlur}
        skuDetailsSalesOnClick={this.skuDetailsSalesOnClick}
        loadSalesTotalFirst={this.loadSalesTotalFirst}
        loadSalesTotalPrevious={this.loadSalesTotalPrevious}
        loadSalesTotalNext={this.loadSalesTotalNext}
        loadSalesTotalLast={this.loadSalesTotalLast}
        salesTotalOnChange={this.salesTotalOnChange}
        salesTotalOnBlur={this.salesTotalOnBlur}
        salesTotalOnClick={this.salesTotalOnClick}
        loadCustomerBarChartPrevious={this.loadCustomerBarChartPrevious}
        loadCustomerBarChartNext={this.loadCustomerBarChartNext}
        handleCustomerBarChartOnChange={this.handleCustomerBarChartOnChange}
        handleCustomerBarChartPaginationOnBlur={
          this.handleCustomerBarChartPaginationOnBlur
        }
        handleCustomerBarChartPageClick={this.handleCustomerBarChartPageClick}
        loadItemBarChartPrevious={this.loadItemBarChartPrevious}
        loadItemSalesBarChartNext={this.loadItemSalesBarChartNext}
        handleItemSalesBarChartOnChange={this.handleItemSalesBarChartOnChange}
        handleItemSalesBarChartPaginationOnBlur={
          this.handleItemSalesBarChartPaginationOnBlur
        }
        handleItemSalesBarChartPageClick={this.handleItemSalesBarChartPageClick}
        loadYearlyBarChartPrevious={this.loadYearlyBarChartPrevious}
        loadYearlyBarChartNext={this.loadYearlyBarChartNext}
        handleYearlyBarChartOnChange={this.handleYearlyBarChartOnChange}
        handleYearlyBarChartPaginationOnBlur={
          this.handleYearlyBarChartPaginationOnBlur
        }
        handleYearlyBarChartPageClick={this.handleYearlyBarChartPageClick}
        loadLotSalesBarChartPrevious={this.loadLotSalesBarChartPrevious}
        loadLotSalesBarChartNext={this.loadLotSalesBarChartNext}
        handleLotSalesBarChartOnChange={this.handleLotSalesBarChartOnChange}
        handleLotSalesBarChartPaginationOnBlur={
          this.handleLotSalesBarChartPaginationOnBlur
        }
        handleLotSalesBarChartPageClick={this.handleLotSalesBarChartPageClick}
        salesChartHandler={this.salesChartHandler}
      />
    );
  }

  loadCustomerBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.customerSalesBarChartCurrentPage) + 1,
          prevState.customerSalesBardChartTotalPage,
        );
        return { customerSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.customerSalesBarChart();
      },
    );
  };

  loadCustomerBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.customerSalesBarChartCurrentPage) - 1,
          1,
        );
        return { customerSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.customerSalesBarChart();
      },
    );
  };

  handleCustomerBarChartOnChange = (e) => {
    let customerSalesBarChartCurrentPage =
      this.state.customerSalesBarChartCurrentPage;
    customerSalesBarChartCurrentPage = e.target.value;
    this.setState({
      customerSalesBarChartCurrentPage: customerSalesBarChartCurrentPage,
    });
  };

  handleCustomerBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.customerSalesBardChartTotalPage) {
          newPage = prevState.customerSalesBardChartTotalPage; // Cap at total pages
        }

        return { customerSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.customerSalesBarChart();
      },
    );
  };

  handleCustomerBarChartPageClick = (e) => {
    let customerSalesBarChartCurrentPage = e;
    this.setState(
      {
        customerSalesBarChartCurrentPage: customerSalesBarChartCurrentPage,
      },
      () => {
        this.customerSalesBarChart();
      },
    );
  };

  loadItemSalesBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.itemSalesBarChartCurrentPage) + 1,
          prevState.itemSalesBardChartTotalPage,
        );
        return { itemSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.itemSalesBarChart();
      },
    );
  };

  loadItemBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.itemSalesBarChartCurrentPage) - 1,
          1,
        );
        return { itemSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.itemSalesBarChart();
      },
    );
  };

  handleItemSalesBarChartOnChange = (e) => {
    let itemSalesBarChartCurrentPage = this.state.itemSalesBarChartCurrentPage;
    itemSalesBarChartCurrentPage = e.target.value;
    this.setState({
      itemSalesBarChartCurrentPage: itemSalesBarChartCurrentPage,
    });
  };

  handleItemSalesBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.itemSalesBardChartTotalPage) {
          newPage = prevState.itemSalesBardChartTotalPage; // Cap at total pages
        }

        return { itemSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.itemSalesBarChart();
      },
    );
  };

  handleItemSalesBarChartPageClick = (e) => {
    let itemSalesBarChartCurrentPage = e;
    this.setState(
      {
        itemSalesBarChartCurrentPage: itemSalesBarChartCurrentPage,
      },
      () => {
        this.itemSalesBarChart();
      },
    );
  };

  loadYearlyBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.yearlyBarChartCurrentPage) + 1,
          prevState.yearlyBardChartTotalPage,
        );
        return { yearlyBarChartCurrentPage: newPage };
      },
      () => {
        this.yearlySalesBarChart();
      },
    );
  };

  // BEFORE
  // loadYearlyBarChartPrevious = () => {
  //     this.setState(
  //       (prevState) => {
  //         const newPage = Math.max(
  //           parseInt(prevState.itemSalesBarChartCurrentPage) - 1,   // ← wrong
  //           1,
  //         );
  //         return { itemSalesBarChartCurrentPage: newPage };          // ← wrong
  //       },
  //       () => { this.yearlySalesBarChart(); },
  //     );
  // };

  // AFTER
  loadYearlyBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.yearlyBarChartCurrentPage) - 1,
          1,
        );
        return { yearlyBarChartCurrentPage: newPage };
      },
      () => {
        this.yearlySalesBarChart();
      },
    );
  };

  handleYearlyBarChartOnChange = (e) => {
    let yearlyBarChartCurrentPage = this.state.yearlyBarChartCurrentPage;
    yearlyBarChartCurrentPage = e.target.value;
    this.setState({
      yearlyBarChartCurrentPage: yearlyBarChartCurrentPage,
    });
  };

  handleYearlyBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.yearlyBardChartTotalPage) {
          newPage = prevState.yearlyBardChartTotalPage; // Cap at total pages
        }

        return { yearlyBarChartCurrentPage: newPage };
      },
      () => {
        this.yearlySalesBarChart();
      },
    );
  };

  handleYearlyBarChartPageClick = (e) => {
    let yearlyBarChartCurrentPage = e;
    this.setState(
      {
        yearlyBarChartCurrentPage: yearlyBarChartCurrentPage,
      },
      () => {
        this.yearlySalesBarChart();
      },
    );
  };

  loadLotSalesBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.lotSalesBarChartCurrentPage) + 1,
          prevState.lotSalesBardChartTotalPage,
        );
        return { lotSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.lotSalesBarChart();
      },
    );
  };

  loadLotSalesBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.lotSalesBarChartCurrentPage) - 1,
          1,
        );
        return { lotSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.lotSalesBarChart();
      },
    );
  };

  handleLotSalesBarChartOnChange = (e) => {
    let lotSalesBarChartCurrentPage = this.state.lotSalesBarChartCurrentPage;
    lotSalesBarChartCurrentPage = e.target.value;
    this.setState({
      lotSalesBarChartCurrentPage: lotSalesBarChartCurrentPage,
    });
  };

  handleLotSalesBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.lotSalesBardChartTotalPage) {
          newPage = prevState.lotSalesBardChartTotalPage; // Cap at total pages
        }

        return { lotSalesBarChartCurrentPage: newPage };
      },
      () => {
        this.lotSalesBarChart();
      },
    );
  };

  // BEFORE
  // handleLotSalesBarChartPageClick = (e) => {
  //     let lotSalesBarChartCurrentPage = e;
  //     this.setState(
  //       { lotSalesBarChartCurrentPage: lotSalesBarChartCurrentPage },
  //       () => { this.yearlySalesBarChart(); }   // ← wrong
  //     );
  // };

  // AFTER
  handleLotSalesBarChartPageClick = (e) => {
    let lotSalesBarChartCurrentPage = e;
    this.setState(
      { lotSalesBarChartCurrentPage: lotSalesBarChartCurrentPage },
      () => {
        this.lotSalesBarChart();
      }, // ← correct
    );
  };

  loadVendorPurchaseBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.vendorPurchaseBarChartCurrentPage) + 1,
          prevState.vendorPurchaseBarChartTotalPage,
        );
        return { vendorPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseBarChart();
      },
    );
  };

  loadVendorPurchaseBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.vendorPurchaseBarChartCurrentPage) - 1,
          1,
        );
        return { vendorPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseBarChart();
      },
    );
  };

  handleVendorPurchaseBarChartOnChange = (e) => {
    let vendorPurchaseBarChartCurrentPage =
      this.state.vendorPurchaseBarChartCurrentPage;
    vendorPurchaseBarChartCurrentPage = e.target.value;
    this.setState({
      vendorPurchaseBarChartCurrentPage: vendorPurchaseBarChartCurrentPage,
    });
  };

  handleVendorPurchaseBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.vendorPurchaseBarChartTotalPage) {
          newPage = prevState.vendorPurchaseBarChartTotalPage; // Cap at total pages
        }

        return { vendorPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseBarChart();
      },
    );
  };

  handleVendorPurchaseBarChartPageClick = (e) => {
    let vendorPurchaseBarChartCurrentPage = e;
    this.setState(
      {
        vendorPurchaseBarChartCurrentPage: vendorPurchaseBarChartCurrentPage,
      },
      () => {
        this.loadVendorPurchaseBarChart();
      },
    );
  };

  loadItemPurchaseBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.itemPurchaseBarChartCurrentPage) + 1,
          prevState.itemPurchaseBarChartTotalPage,
        );
        return { itemPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadItemPurchaseBarChart();
      },
    );
  };

  loadItemPurchaseBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.itemPurchaseBarChartCurrentPage) - 1,
          1,
        );
        return { itemPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadItemPurchaseBarChart();
      },
    );
  };

  handleItemPurchaseBarChartOnChange = (e) => {
    let itemPurchaseBarChartCurrentPage =
      this.state.itemPurchaseBarChartCurrentPage;
    itemPurchaseBarChartCurrentPage = e.target.value;
    this.setState({
      itemPurchaseBarChartCurrentPage: itemPurchaseBarChartCurrentPage,
    });
  };

  // BEFORE
  // handleItemPurchaseBarChartPaginationOnBlur = (e) => {
  //     this.setState(
  //       (prevState) => {
  //         let newPage = parseInt(e.target.value, 10);
  //         if (isNaN(newPage) || newPage < 1) {
  //           newPage = 1;
  //         } else if (newPage > prevState.itemPurchaseBarChartCurrentPage) {   // ← wrong
  //           newPage = prevState.itemPurchaseBarChartCurrentPage;               // ← wrong
  //         }
  //         return { itemPurchaseBarChartCurrentPage: newPage };
  //       },
  //       () => { this.loadItemPurchaseBarChart(); },
  //     );
  // };

  // AFTER
  handleItemPurchaseBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);
        if (isNaN(newPage) || newPage < 1) {
          newPage = 1;
        } else if (newPage > prevState.itemPurchaseBarChartTotalPage) {
          newPage = prevState.itemPurchaseBarChartTotalPage;
        }
        return { itemPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadItemPurchaseBarChart();
      },
    );
  };

  handleItemPurchaseBarChartPageClick = (e) => {
    let itemPurchaseBarChartCurrentPage = e;
    this.setState(
      {
        itemPurchaseBarChartCurrentPage: itemPurchaseBarChartCurrentPage,
      },
      () => {
        this.loadItemPurchaseBarChart();
      },
    );
  };

  loadYearlyPurchaseBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.yearlyPurchaseBarChartCurrentPage) + 1,
          prevState.yearlyPurchaseBarChartTotalPage,
        );
        return { yearlyPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadYearlyPurchaseBarChart();
      },
    );
  };

  loadYearlyPurchaseBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.yearlyPurchaseBarChartCurrentPage) - 1,
          1,
        );
        return { yearlyPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadYearlyPurchaseBarChart();
      },
    );
  };

  handleYearlyPurchaseBarChartOnChange = (e) => {
    let yearlyPurchaseBarChartCurrentPage =
      this.state.yearlyPurchaseBarChartCurrentPage;
    yearlyPurchaseBarChartCurrentPage = e.target.value;
    this.setState({
      yearlyPurchaseBarChartCurrentPage: yearlyPurchaseBarChartCurrentPage,
    });
  };

  handleYearlyPurchaseBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.yearlyPurchaseBarChartTotalPage) {
          newPage = prevState.yearlyPurchaseBarChartTotalPage; // Cap at total pages
        }

        return { yearlyPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadYearlyPurchaseBarChart();
      },
    );
  };

  handleYearlyPurchaseBarChartPageClick = (e) => {
    let yearlyPurchaseBarChartCurrentPage = e;
    this.setState(
      {
        yearlyPurchaseBarChartCurrentPage: yearlyPurchaseBarChartCurrentPage,
      },
      () => {
        this.loadYearlyPurchaseBarChart();
      },
    );
  };

  loadLotPurchaseBarChartNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.lotPurchaseBarChartCurrentPage) + 1,
          prevState.lotPurchaseBarChartTotalPage,
        );
        return { lotPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadLotPurchaseBarChart();
      },
    );
  };

  loadLotPurchaseBarChartPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.lotPurchaseBarChartCurrentPage) - 1,
          1,
        );
        return { lotPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadLotPurchaseBarChart();
      },
    );
  };

  handleLotPurchaseBarChartOnChange = (e) => {
    let lotPurchaseBarChartCurrentPage =
      this.state.lotPurchaseBarChartCurrentPage;
    lotPurchaseBarChartCurrentPage = e.target.value;
    this.setState({
      lotPurchaseBarChartCurrentPage: lotPurchaseBarChartCurrentPage,
    });
  };

  handleLotPurchaseBarChartPaginationOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.lotPurchaseBarChartTotalPage) {
          newPage = prevState.lotPurchaseBarChartTotalPage; // Cap at total pages
        }

        return { lotPurchaseBarChartCurrentPage: newPage };
      },
      () => {
        this.loadLotPurchaseBarChart();
      },
    );
  };

  handleLotPurchaseBarChartPageClick = (e) => {
    let lotPurchaseBarChartCurrentPage = e;
    this.setState(
      {
        lotPurchaseBarChartCurrentPage: lotPurchaseBarChartCurrentPage,
      },
      () => {
        this.loadLotPurchaseBarChart();
      },
    );
  };

  onFabricColourCodeChange = (e) => {
    this.state.showAutoCompleteFabricColorList = true;
    let colorCode = e.target.value;
    let showAutoCompleteFabricColorList =
      this.state.showAutoCompleteFabricColorList;
    if (isEmpty(colorCode)) {
      this.state.showAutoCompleteFabricColorList = false;
      let showAutoCompleteFabricColorList =
        this.state.showAutoCompleteFabricColorList;
      let criteria = this.state.salesCriteria;
      criteria.colorCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteFabricColorList: showAutoCompleteFabricColorList,
        salesCriteria: criteria,
        fabricColourPageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "colorCode" &&
      showAutoCompleteFabricColorList === true &&
      colorCode !== ""
    ) {
      this.readFabricColourBySearchString(e.target.value);
    }
  };
  readFabricColourBySearchString(searchString) {
    let criteria = this.state.salesCriteria;
    criteria.colorCode = searchString;
    let colorList = this.state.colorList;
    let simpleAutoCompleteColorList = new Array();
    colorList.map((colorListData) => {
      let simpleColorBean = {
        code: colorListData.code,
        description: colorListData.description,
      };
      simpleAutoCompleteColorList.push(simpleColorBean);
    });
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteColorList.filter(
      (simpleAutoCompleteColorLists) =>
        simpleAutoCompleteColorLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      fabricColourPageListForAutoCompleteList: filteredSuggestions,
    });
  }
  fabricColourEnterKeyEventHandler = (e) => {
    let fabricStyleColourCode = e.target.value;
    this.fabricStyleColorSelected(fabricStyleColourCode);
    this.setState({ fabricColourPageListForAutoCompleteList: new Array() });
  };
  displayAutoCompleteFabricColorList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteFabricColorList: showAutoCompleteList });
  };
  fabricStyleColorSelected = (colorCode) => {
    let criteria = this.state.salesCriteria;
    criteria.colorCode = colorCode;
    this.setState({ salesCriteria: criteria });
  };
  locationCodeOnChange = (e) => {
    let locationCode = e.target.value;
    this.state.showAutoCompleteLocationList = true;
    let temp_criteria = this.state.salesCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteLocationList;
    if (isEmpty(locationCode)) {
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      let criteria = this.state.salesCriteria;
      criteria.locationCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteLocationList: showAutoCompleteList,
        salesCriteria: criteria,
        showAutoCompleteSalesPersonList: suggestion,
      });
    } else if (showAutoCompleteList === true && locationCode !== "") {
      this.readLocationBySearchString(locationCode);
    }
    temp_criteria[e.target.name] = e.target.value;
    this.setState({ salesCriteria: temp_criteria });
  };
  readLocation = (locationCode) => {
    let locationBean = null;
    let locationData = null;
    this.state.warehouses.map((ln) => {
      if (ln.code === locationCode) {
        locationBean = ln;
        locationData = new BaseBean();
        locationData.code = ln.code;
        locationData.description = ln.description;
      }
    });
    if (!isEmpty(locationBean)) {
      let temp_criteria = this.state.salesCriteria;
      temp_criteria.locationCode = locationBean.code;
      this.state.showAutoCompleteLocationList = false;
      let showAutoCompleteList = this.state.showAutoCompleteLocationList;
      this.setState({
        salesCriteria: temp_criteria,
        showAutoCompleteList: showAutoCompleteList,
      });
    }
    this.setState({ locationList: locationBean, locationData: locationData });
  };
  readLocationBySearchString = (searchString) => {
    let locationData = this.state.warehouses;
    let simpleAutoCompleteList = new Array();
    if (locationData.length > 0 && locationData != null) {
      locationData.map((sp) => {
        let locationBean = {
          code: sp.code,
          description: sp.description,
        };
        simpleAutoCompleteList.push(locationBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (autoList) =>
        autoList.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ locationPageListForAutoCompleteList: filteredSuggestions });
  };
  locationEnterKeyEventHandler = (e) => {
    let locationCode = e.target.value;
    this.readLocation(locationCode);
    this.setState({
      locationPageListForAutoCompleteList: new Array(),
    });
  };
  displayAutoCompleteLocationList = (showAutoCompleteList) => {
    this.setState({ showAutoCompleteLocationList: showAutoCompleteList });
  };
  onPopupUomCodeChange = (e) => {
    let uomCode = e.target.value;
    this.state.showAutoCompleteUOMPopupList = true;
    let criteria = this.state.salesCriteria;
    let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
    if (isEmpty(uomCode)) {
      this.state.showAutoCompleteUOMPopupList = false;
      let showAutoCompleteList = this.state.showAutoCompleteUOMPopupList;
      let criteria = this.state.salesCriteria;
      criteria.uomCode = "";
      let suggestion = [];
      this.setState({
        showAutoCompleteUOMPopupList: showAutoCompleteList,
        salesCriteria: criteria,
        uomPopupPageListForAutoCompleteList: suggestion,
      });
    } else if (showAutoCompleteList === true && uomCode !== "") {
      this.readPopupUomCodeBySearchString(uomCode);
    }
    criteria[e.target.name] = e.target.value;
    this.setState({ salesCriteria: criteria });
  };
  readPopupUomCodeBySearchString(searchString) {
    let uomCodeData = this.state.uoms;
    let simpleAutoCompleteList = new Array();
    if (uomCodeData.length > 0 && uomCodeData != null) {
      uomCodeData.map((uomCodeDatas) => {
        let simpleItemBean = {
          code: uomCodeDatas.code,
          description: uomCodeDatas.description,
        };
        simpleAutoCompleteList.push(simpleItemBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (simpleAutoCompleteUomCodeLists) =>
        simpleAutoCompleteUomCodeLists.code
          .toLowerCase()
          .indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({ uomPopupPageListForAutoCompleteList: filteredSuggestions });
  }
  uomPopupEnterKeyEventHandler = (e) => {
    let criteria = this.state.salesCriteria;
    let uomCode = e.target.value;
    criteria.uomCode = uomCode;
    let uomData_List = this.state.uoms;
    let UomCodeBean = null;
    uomData_List.map((uom) => {
      if (uom.code == e.target.value) {
        UomCodeBean = uom;
      }
    });
    if (!isEmpty(UomCodeBean)) {
      let criteria = this.state.salesCriteria;
      criteria.uomCode = UomCodeBean.code;
      this.setState({
        criteria: criteria,
        uomPopupPageListForAutoCompleteList: new Array(),
      });
    }
  };
  displayAutoCompleteUomPopupList = (showAutoCompleteUOMPopupList) => {
    this.setState({
      showAutoCompleteUOMPopupList: showAutoCompleteUOMPopupList,
    });
  };

  //--------------------------------------------------------------------------------------------------------------------//

  executeInventoryList = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    this.loadInventoryList();
  };
  resetInventoryList = () => {
    let tempCriteria = new FabricStyleDashBoardCriteriaBean();
    tempCriteria.companyCode = this.companyCode;
    tempCriteria.fabricStyleName = "";
    this.setState({
      isDisableFields: false,
      salesCriteria: tempCriteria,
    });
    this.state.salesCriteria = tempCriteria;
    this.executeInventoryList();
  };

  loadInventoryList = () => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Executing...",
    });
    let criteria = this.state.salesCriteria;
    criteria.companyCode = this.companyCode;

    // console.log("criteria inventory", criteria);

    //  if (SecurityAccessManager.CustomerSalesDetailsInquiry_IsAccessible()) {
    ReportService.getFabricDashBoardInventoryValuationDetails(
      criteria,
      this.loadInventoryPageResponse,
      this.errorCallBack,
    );
  };
  loadInventoryPageResponse = (response) => {
    let totalLandedCostInventoryAmount = 0;
    let totalOnHandQuantity = 0;
    let isInventoryInquiryDataFound = false;
    let inventoryResultData = null;
    let inventoryList = [];
    let inBoundServiceTotalPage = this.state.inBoundServiceTotalPage;
    if (response.data != null && response.data.inventoryResult != null) {
      isInventoryInquiryDataFound = true;
      inventoryResultData = response.data.inventoryResult;
      totalLandedCostInventoryAmount =
        response.data.inventoryResult.totalLandedCostInventoryAmount;
      totalOnHandQuantity = response.data.inventoryResult.totalOnHandQuantity;
      if (!isEmptyArray(response.data.inventoryResult.valuationInfos)) {
        inventoryList = response.data.inventoryResult.valuationInfos;
      }
    }
    this.setState({
      isInventoryInquiryDataFound: isInventoryInquiryDataFound,
      isShowProgressBarPopup: false,
      progressLoadingText: "",
      totalInBoundServiceAmount: totalLandedCostInventoryAmount,
      inventoryList: inventoryList,

      isShowProgressBarPopup: false,
      progressLoadingText: "",
      inventoryResultData: inventoryResultData,
    });
  };

  getPurchaseView() {
    return (
      <PurchaseViewForm
        {...this.state}
        vendorCodeOnChange={this.vendorCodeOnChange}
        vendorCodeEnterKeyEventHandler={this.vendorCodeEnterKeyEventHandler}
        displayAutoCompleteVendorList={this.displayAutoCompleteVendorList}
        fabricCodeOnChange={this.fabricCodeOnChange}
        fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
        displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        executePurchaseVendor={this.executePurchaseVendor}
        purchaseOnChange={this.purchaseOnChange}
        salesOnChange={this.salesOnChange}
        resetPurchaseVendor={this.resetPurchaseVendor}
        closeNav={this.closeNav}
        viewCustomerModule={this.viewCustomerModule}
        viewFabricModule={this.viewFabricModule}
        viewInvoiceModule={this.viewInvoiceModule}
        viewVendorModule={this.viewVendorModule}
        viewPOModule={this.viewPOModule}
        viewPRModule={this.viewPRModule}
        yearClickHandler={this.yearClickHandler}
        fabricPurchaseInfoexcelHandler={this.fabricPurchaseInfoexcelHandler}
        vendorPurchaseInfoExcelHandler={this.vendorPurchaseInfoExcelHandler}
        skuDetailPOExcelHandler={this.skuDetailPOExcelHandler}
        vendorSummaryPOExcelHandler={this.vendorSummaryPOExcelHandler}
        loadFabricPurchasePrevious={this.loadFabricPurchasePrevious}
        loadFabricPurchaseNext={this.loadFabricPurchaseNext}
        fabricPurchaseOnChange={this.fabricPurchaseOnChange}
        fabricPurchaseOnBlur={this.fabricPurchaseOnBlur}
        handleFabricPurchasePageClick={this.handleFabricPurchasePageClick}
        loadVendorPurchasePrevious={this.loadVendorPurchasePrevious}
        loadVendorPurchaseNext={this.loadVendorPurchaseNext}
        vendorPurchaseOnChange={this.vendorPurchaseOnChange}
        vendorPurchaseOnBlur={this.vendorPurchaseOnBlur}
        handleVendorPurchasePageClick={this.handleVendorPurchasePageClick}
        loadFabricVendor_PurchasePrevious={
          this.loadFabricVendor_PurchasePrevious
        }
        loadFabricVendor_PurchaseNext={this.loadFabricVendor_PurchaseNext}
        fabricVendor_PurchaseOnChange={this.fabricVendor_PurchaseOnChange}
        fabricVendor_PurchaseOnBlur={this.fabricVendor_PurchaseOnBlur}
        handlefabricVendor_PurchasePageClick={
          this.handlefabricVendor_PurchasePageClick
        }
        loadVendorSummaryPurchasePrevious={
          this.loadVendorSummaryPurchasePrevious
        }
        loadVendorSummaryPurchaseNext={this.loadVendorSummaryPurchaseNext}
        vendorSummaryPurchaseOnChange={this.vendorSummaryPurchaseOnChange}
        vendorSummaryVendorPurchaseOnBlur={
          this.vendorSummaryVendorPurchaseOnBlur
        }
        handleVendorSummaryPurchasePageClick={
          this.handleVendorSummaryPurchasePageClick
        }
        loadVendorPurchaseBarChartPrevious={
          this.loadVendorPurchaseBarChartPrevious
        }
        loadVendorPurchaseBarChartNext={this.loadVendorPurchaseBarChartNext}
        handleVendorPurchaseBarChartOnChange={
          this.handleVendorPurchaseBarChartOnChange
        }
        handleVendorPurchaseBarChartPaginationOnBlur={
          this.handleVendorPurchaseBarChartPaginationOnBlur
        }
        handleVendorPurchaseBarChartPageClick={
          this.handleVendorPurchaseBarChartPageClick
        }
        loadItemPurchaseBarChartPrevious={this.loadItemPurchaseBarChartPrevious}
        loadItemPurchaseBarChartNext={this.loadItemPurchaseBarChartNext}
        handleItemPurchaseBarChartOnChange={
          this.handleItemPurchaseBarChartOnChange
        }
        handleItemPurchaseBarChartPaginationOnBlur={
          this.handleItemPurchaseBarChartPaginationOnBlur
        }
        handleItemPurchaseBarChartPageClick={
          this.handleItemPurchaseBarChartPageClick
        }
        loadYearlyPurchaseBarChartPrevious={
          this.loadYearlyPurchaseBarChartPrevious
        }
        loadYearlyPurchaseBarChartNext={this.loadYearlyPurchaseBarChartNext}
        handleYearlyPurchaseBarChartOnChange={
          this.handleYearlyPurchaseBarChartOnChange
        }
        handleYearlyPurchaseBarChartPaginationOnBlur={
          this.handleYearlyPurchaseBarChartPaginationOnBlur
        }
        handleYearlyPurchaseBarChartPageClick={
          this.handleYearlyPurchaseBarChartPageClick
        }
        loadLotPurchaseBarChartPrevious={this.loadLotPurchaseBarChartPrevious}
        loadLotPurchaseBarChartNext={this.loadLotPurchaseBarChartNext}
        handleLotPurchaseBarChartOnChange={
          this.handleLotPurchaseBarChartOnChange
        }
        handleLotPurchaseBarChartPaginationOnBlur={
          this.handleLotPurchaseBarChartPaginationOnBlur
        }
        handleLotPurchaseBarChartPageClick={
          this.handleLotPurchaseBarChartPageClick
        }
      />
    );
  }

  getServiceView = () => {
    return (
      <ServiceViewForm
        {...this.state}
        customerCodeOnChange={this.customerCodeOnChange}
        customerCodeEnterKeyEventHandler={this.customerCodeEnterKeyEventHandler}
        displayAutoCompleteCustomerList={this.displayAutoCompleteCustomerList}
        executeServiceList={this.executeServiceList}
        resetServiceList={this.resetServiceList}
        salesOnChange={this.salesOnChange}
        viewCustomerModule={this.viewCustomerModule}
        closeNav={this.closeNav}
        serviceOnChange={this.serviceOnChange}
        serviceEnterKeyEvent={this.serviceEnterKeyEvent}
        displayServiceAutoCompleteList={this.displayServiceAutoCompleteList}
        loadServiceInboundPrevious={this.loadServiceInboundPrevious}
        loadServiceInboundNext={this.loadServiceInboundNext}
        serviceInvoundOnChange={this.serviceInvoundOnChange}
        serviceInboundOnBlur={this.serviceInboundOnBlur}
        handleServiceInboundPageClick={this.handleServiceInboundPageClick}
        loadServiceOutBoundPrevious={this.loadServiceOutBoundPrevious}
        loadServiceOutBoundNext={this.loadServiceOutBoundNext}
        serviceOutBoundOnChange={this.serviceOutBoundOnChange}
        serviceOutBoundOnBlur={this.serviceOutBoundOnBlur}
        serviceOutBoundPageClick={this.serviceOutBoundPageClick}
      />
    );
  };

  getInventoryView = () => {
    return (
      <InventoryViewForm
        {...this.state}
        fabricCodeOnChange={this.fabricCodeOnChange}
        fabricEnterKeyEventHandler={this.fabricEnterKeyEventHandler}
        displayAutoCompleteFabricList={this.displayAutoCompleteFabricList}
        displayAutoCompleteFabricColorList={
          this.displayAutoCompleteFabricColorList
        }
        onFabricColourCodeChange={this.onFabricColourCodeChange}
        locationEnterKeyEventHandler={this.locationEnterKeyEventHandler}
        displayAutoCompleteLocationList={this.displayAutoCompleteLocationList}
        locationCodeOnChange={this.locationCodeOnChange}
        uomPopupEnterKeyEventHandler={this.uomPopupEnterKeyEventHandler}
        displayAutoCompleteUomPopupList={this.displayAutoCompleteUomPopupList}
        onPopupUomCodeChange={this.onPopupUomCodeChange}
        viewFabricModule={this.viewFabricModule}
        executeInventoryList={this.executeInventoryList}
        resetInventoryList={this.resetInventoryList}
        inventoryChartHandler={this.inventoryChartHandler}
      />
    );
  };

  serviceOnChange = (e) => {
    let serviceCode = e.target.value;
    this.state.isShowAutoCompleteServiceList = true;
    let tempData = this.state.salesCriteria;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    if (isEmpty(serviceCode)) {
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      let tempData = this.state.salesCriteria;
      tempData.serviceCode = "";
      tempData.serviceName = "";
      let suggestion = [];
      this.setState({
        isShowAutoCompleteServiceList: showAutoCompleteList,
        salesCriteria: tempData,
        servicePageListForAutoCompleteList: suggestion,
      });
    } else if (
      e.target.name == "serviceCode" &&
      showAutoCompleteList === true &&
      serviceCode !== ""
    ) {
      this.readServiceBySearchString(e.target.value);
      this.readService(e.target.value);
    }
    tempData[e.target.name] = e.target.value.toUpperCase();
    this.setState({ salesCriteria: tempData });
  };
  serviceEnterKeyEvent = (e) => {
    this.readService(e.target.value);
    this.state.isShowAutoCompleteServiceList = false;
    let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
    this.setState({
      servicePageListForAutoCompleteList: new Array(),
      isShowAutoCompleteServiceList: showAutoCompleteList,
    });
  };
  displayServiceAutoCompleteList = (isShowAutoCompleteList) => {
    this.setState({
      isShowAutoCompleteServiceList: isShowAutoCompleteList,
    });
  };
  readServiceBySearchString = (searchString) => {
    let serviceData = this.state.services;
    let simpleAutoCompleteList = new Array();
    if (serviceData.length > 0 && serviceData != null) {
      serviceData.map((obj) => {
        let serivceBean = {
          description: obj.description,
          code: obj.code,
        };
        simpleAutoCompleteList.push(serivceBean);
      });
    }
    let userInput = searchString;
    let filteredSuggestions = new Array();
    filteredSuggestions = simpleAutoCompleteList.filter(
      (list) => list.code.toLowerCase().indexOf(userInput.toLowerCase()) > -1,
    );
    this.setState({
      servicePageListForAutoCompleteList: filteredSuggestions,
    });
  };
  readService = (serviceCode) => {
    let tempData = this.state.salesCriteria;
    let serivceBean = null;
    let serviceData = null;
    this.state.services.map((ln) => {
      if (ln.code === serviceCode) {
        serivceBean = ln;
        serviceData = new BaseBean();
        serviceData.code = ln.code;
        serviceData.description = ln.description;
      }
    });

    if (!isEmpty(serivceBean)) {
      //  let temp_criteria = this.state.criteria;
      tempData.serviceCode = serivceBean.code;
      tempData.serviceName = serivceBean.description;
      this.state.isShowAutoCompleteServiceList = false;
      let showAutoCompleteList = this.state.isShowAutoCompleteServiceList;
      this.setState({
        criteria: tempData,
        isShowAutoCompleteServiceList: showAutoCompleteList,
      });
    }
  };

  loadSalesAnalysisPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.salesAnalysisCurrentPage) - 1,
          1,
        );
        return { salesAnalysisCurrentPage: newPage };
      },
      () => {
        this.loadFabricSalesAnalysis();
      },
    );
  };

  loadSalesAnalysisNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.salesAnalysisCurrentPage) + 1,
          prevState.salesAnalysisTotalPage,
        );

        return { salesAnalysisCurrentPage: newPage };
      },
      () => {
        this.loadFabricSalesAnalysis();
      },
    );
  };
  loadSalesAnalysisFirst = () => {
    this.setState({ salesAnalysisCurrentPage: 1 }, () => {
      this.loadFabricSalesAnalysis();
    });
  };

  loadSalesAnalysisLast = () => {
    this.setState(
      { salesAnalysisCurrentPage: this.state.salesAnalysisTotalPage },
      () => {
        this.loadFabricSalesAnalysis();
      },
    );
  };

  salesInfosOnChange = (e) => {
    let salesAnalysisCurrentPage = this.state.salesAnalysisCurrentPage;
    salesAnalysisCurrentPage = e.target.value;
    this.setState({
      salesAnalysisCurrentPage: salesAnalysisCurrentPage,
    });
  };

  salesInfosOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.salesAnalysisTotalPage) {
          newPage = prevState.salesAnalysisTotalPage; // Cap at total pages
        }

        return { salesAnalysisCurrentPage: newPage };
      },
      () => {
        this.loadFabricSalesAnalysis();
      },
    );
  };

  handleCustomerSalesBardChartPageClick = (e) => {
    let salesAnalysisCurrentPage = e;
    this.setState(
      {
        salesAnalysisCurrentPage: salesAnalysisCurrentPage,
      },
      () => {
        this.loadFabricSalesAnalysis();
      },
    );
  };

  loadCustomerSalesPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.customerSalesCurrentPage) - 1,
          1,
        );
        return { customerSalesCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSalesAnalysis();
      },
    );
  };

  loadCustomerSalesNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.customerSalesCurrentPage) + 1,
          prevState.customerSalesTotalPage,
        );
        return { customerSalesCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSalesAnalysis();
      },
    );
  };
  loadCustomerSalesFirst = () => {
    this.setState({ customerSalesCurrentPage: 1 }, () => {
      this.loadCustomerSalesAnalysis();
    });
  };

  loadCustomerSalesLast = () => {
    this.setState(
      { customerSalesCurrentPage: this.state.customerSalesTotalPage },
      () => {
        this.loadCustomerSalesAnalysis();
      },
    );
  };

  customerSalesOnChange = (e) => {
    let customerSalesCurrentPage = this.state.customerSalesCurrentPage;
    customerSalesCurrentPage = e.target.value;
    this.setState({
      customerSalesCurrentPage: customerSalesCurrentPage,
    });
  };

  customerSalesOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.customerSalesTotalPage) {
          newPage = prevState.customerSalesTotalPage; // Cap at total pages
        }

        return { customerSalesCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSalesAnalysis();
      },
    );
  };

  customerSalesOnClick = (e) => {
    let customerSalesCurrentPage = e;
    this.setState(
      {
        customerSalesCurrentPage: customerSalesCurrentPage,
      },
      () => {
        this.loadCustomerSalesAnalysis();
      },
    );
  };

  loadSkuDetailPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.skuDetailsCurrentPage) - 1,
          1,
        );
        return { skuDetailsCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndCustomerSalesAnalysis();
      },
    );
  };

  loadSkuDetailNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.skuDetailsCurrentPage) + 1,
          prevState.skuDetailsTotalPage,
        );
        return { skuDetailsCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndCustomerSalesAnalysis();
      },
    );
  };
  loadSkuDetailFirst = () => {
    this.setState({ skuDetailsCurrentPage: 1 }, () => {
      this.loadFabricAndCustomerSalesAnalysis();
    });
  };

  loadSkuDetailLast = () => {
    this.setState(
      { skuDetailsCurrentPage: this.state.skuDetailsTotalPage },
      () => {
        this.loadFabricAndCustomerSalesAnalysis();
      },
    );
  };

  skuDetailsOnChange = (e) => {
    let skuDetailsCurrentPage = this.state.skuDetailsCurrentPage;
    skuDetailsCurrentPage = e.target.value;
    this.setState({
      skuDetailsCurrentPage: skuDetailsCurrentPage,
    });
  };

  skuDetailsSalesOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.skuDetailsTotalPage) {
          newPage = prevState.skuDetailsTotalPage; // Cap at total pages
        }

        return { skuDetailsCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndCustomerSalesAnalysis();
      },
    );
  };

  skuDetailsSalesOnClick = (e) => {
    let skuDetailsCurrentPage = e;
    this.setState(
      {
        skuDetailsCurrentPage: skuDetailsCurrentPage,
      },
      () => {
        this.loadFabricAndCustomerSalesAnalysis();
      },
    );
  };

  loadSalesTotalPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.salesTotalCurrentPage) - 1,
          1,
        );
        return { salesTotalCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSummarySalesDetail();
      },
    );
  };

  loadSalesTotalNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.salesTotalCurrentPage) + 1,
          prevState.salesTotalPage,
        );
        return { salesTotalCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSummarySalesDetail();
      },
    );
  };
  loadSalesTotalFirst = () => {
    this.setState({ salesTotalCurrentPage: 1 }, () => {
      this.loadCustomerSummarySalesDetail();
    });
  };

  loadSalesTotalLast = () => {
    this.setState({ salesTotalCurrentPage: this.state.salesTotalPage }, () => {
      this.loadCustomerSummarySalesDetail();
    });
  };

  salesTotalOnChange = (e) => {
    let salesTotalCurrentPage = this.state.salesTotalCurrentPage;
    salesTotalCurrentPage = e.target.value;
    this.setState({
      salesTotalCurrentPage: salesTotalCurrentPage,
    });
  };

  salesTotalOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.salesTotalPage) {
          newPage = prevState.salesTotalPage; // Cap at total pages
        }

        return { salesTotalCurrentPage: newPage };
      },
      () => {
        this.loadCustomerSummarySalesDetail();
      },
    );
  };

  salesTotalOnClick = (e) => {
    let salesTotalCurrentPage = e;
    this.setState(
      {
        salesTotalCurrentPage: salesTotalCurrentPage,
      },
      () => {
        this.loadCustomerSummarySalesDetail();
      },
    );
  };

  loadFabricPurchasePrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.fabricPurchaseCurrentPage) - 1,
          1,
        );
        return { fabricPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricPurchaseAnalysis();
      },
    );
  };

  loadFabricPurchaseNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.fabricPurchaseCurrentPage) + 1,
          prevState.fabricPurchaseTotalPage,
        );
        return { fabricPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricPurchaseAnalysis();
      },
    );
  };

  fabricPurchaseOnChange = (e) => {
    let fabricPurchaseCurrentPage = this.state.fabricPurchaseCurrentPage;
    fabricPurchaseCurrentPage = e.target.value;
    this.setState({
      fabricPurchaseCurrentPage: fabricPurchaseCurrentPage,
    });
  };

  fabricPurchaseOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1;
        } else if (newPage > prevState.fabricPurchaseTotalPage) {
          newPage = prevState.fabricPurchaseTotalPage;
        }

        return { fabricPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricPurchaseAnalysis();
      },
    );
  };

  handleFabricPurchasePageClick = (e) => {
    let fabricPurchaseCurrentPage = e;
    this.setState(
      {
        fabricPurchaseCurrentPage: fabricPurchaseCurrentPage,
      },
      () => {
        this.loadFabricPurchaseAnalysis();
      },
    );
  };

  loadVendorPurchasePrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.vendorPurchaseCurrentPage) - 1,
          1,
        );
        return { vendorPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseAnalysis();
      },
    );
  };

  loadVendorPurchaseNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.vendorPurchaseCurrentPage) + 1,
          prevState.vendorPurchaseTotalPage,
        );
        return { vendorPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseAnalysis();
      },
    );
  };

  vendorPurchaseOnChange = (e) => {
    let vendorPurchaseCurrentPage = this.state.vendorPurchaseCurrentPage;
    vendorPurchaseCurrentPage = e.target.value;
    this.setState({
      vendorPurchaseCurrentPage: vendorPurchaseCurrentPage,
    });
  };

  vendorPurchaseOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.vendorPurchaseTotalPage) {
          newPage = prevState.vendorPurchaseTotalPage; // Cap at total pages
        }

        return { vendorPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorPurchaseAnalysis();
      },
    );
  };

  handleVendorPurchasePageClick = (e) => {
    let vendorPurchaseCurrentPage = e;
    this.setState(
      {
        vendorPurchaseCurrentPage: vendorPurchaseCurrentPage,
      },
      () => {
        this.loadVendorPurchaseAnalysis();
      },
    );
  };

  loadFabricVendor_PurchasePrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.fabricvendor_PurchaseCurrentPage) - 1,
          1,
        );
        return { fabricvendor_PurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndVendorPurchaseAnalysis();
      },
    );
  };

  loadFabricVendor_PurchaseNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.fabricvendor_PurchaseCurrentPage) + 1,
          prevState.fabricVendor_PurchaseTotalPage,
        );
        return { fabricvendor_PurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndVendorPurchaseAnalysis();
      },
    );
  };

  fabricVendor_PurchaseOnChange = (e) => {
    let fabricvendor_PurchaseCurrentPage =
      this.state.fabricvendor_PurchaseCurrentPage;
    fabricvendor_PurchaseCurrentPage = e.target.value;
    this.setState({
      fabricvendor_PurchaseCurrentPage: fabricvendor_PurchaseCurrentPage,
    });
  };

  fabricVendor_PurchaseOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.fabricVendor_PurchaseTotalPage) {
          newPage = prevState.fabricVendor_PurchaseTotalPage; // Cap at total pages
        }

        return { fabricvendor_PurchaseCurrentPage: newPage };
      },
      () => {
        this.loadFabricAndVendorPurchaseAnalysis();
      },
    );
  };

  handlefabricVendor_PurchasePageClick = (e) => {
    let fabricvendor_PurchaseCurrentPage = e;
    this.setState(
      {
        fabricvendor_PurchaseCurrentPage: fabricvendor_PurchaseCurrentPage,
      },
      () => {
        this.loadFabricAndVendorPurchaseAnalysis();
      },
    );
  };

  loadVendorSummaryPurchasePrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.vendorSummaryPurchaseCurrentPage) - 1,
          1,
        );
        return { vendorSummaryPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorSummaryPurchaseDetail();
      },
    );
  };

  loadVendorSummaryPurchaseNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.vendorSummaryPurchaseCurrentPage) + 1,
          prevState.vendorSummaryPurchaseTotalPage,
        );
        return { vendorSummaryPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorSummaryPurchaseDetail();
      },
    );
  };

  vendorSummaryPurchaseOnChange = (e) => {
    let vendorSummaryPurchaseCurrentPage =
      this.state.vendorSummaryPurchaseCurrentPage;
    vendorSummaryPurchaseCurrentPage = e.target.value;
    this.setState({
      vendorSummaryPurchaseCurrentPage: vendorSummaryPurchaseCurrentPage,
    });
  };

  vendorSummaryVendorPurchaseOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.vendorSummaryPurchaseTotalPage) {
          newPage = prevState.vendorSummaryPurchaseTotalPage; // Cap at total pages
        }

        return { vendorSummaryPurchaseCurrentPage: newPage };
      },
      () => {
        this.loadVendorSummaryPurchaseDetail();
      },
    );
  };

  handleVendorSummaryPurchasePageClick = (e) => {
    let vendorSummaryPurchaseCurrentPage = e;
    this.setState(
      {
        vendorSummaryPurchaseCurrentPage: vendorSummaryPurchaseCurrentPage,
      },
      () => {
        this.loadVendorSummaryPurchaseDetail();
      },
    );
  };

  //------------------------Pagination End-------------------------------------------------

  //**********************Service Table - Pagination */

  loadServiceInboundPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.inBoundServiceCurrentPage) - 1,
          1,
        );
        return { inBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadInboundPageList();
      },
    );
  };

  loadServiceInboundNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.inBoundServiceCurrentPage) + 1,
          prevState.inBoundServiceTotalPage,
        );
        return { inBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadInboundPageList();
      },
    );
  };

  serviceInvoundOnChange = (e) => {
    let inBoundServiceCurrentPage = this.state.inBoundServiceCurrentPage;
    inBoundServiceCurrentPage = e.target.value;
    this.setState({
      inBoundServiceCurrentPage: inBoundServiceCurrentPage,
    });
  };

  serviceInboundOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.inBoundServiceTotalPage) {
          newPage = prevState.inBoundServiceTotalPage; // Cap at total pages
        }

        return { inBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadInboundPageList();
      },
    );
  };

  handleServiceInboundPageClick = (e) => {
    let inBoundServiceCurrentPage = e;
    this.setState(
      {
        inBoundServiceCurrentPage: inBoundServiceCurrentPage,
      },
      () => {
        this.loadInboundPageList();
      },
    );
  };

  //********************OuTBoundService - Pagination */

  loadServiceOutBoundPrevious = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.max(
          parseInt(prevState.outBoundServiceCurrentPage) - 1,
          1,
        );
        return { outBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadOutboundPageList();
      },
    );
  };

  loadServiceOutBoundNext = () => {
    this.setState(
      (prevState) => {
        const newPage = Math.min(
          parseInt(prevState.outBoundServiceCurrentPage) + 1,
          prevState.outBoundServiceTotalPage,
        );
        return { outBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadOutboundPageList();
      },
    );
  };

  serviceOutBoundOnChange = (e) => {
    let outBoundServiceCurrentPage = this.state.outBoundServiceCurrentPage;
    outBoundServiceCurrentPage = e.target.value;
    this.setState({
      outBoundServiceCurrentPage: outBoundServiceCurrentPage,
    });
  };

  serviceOutBoundOnBlur = (e) => {
    this.setState(
      (prevState) => {
        let newPage = parseInt(e.target.value, 10);

        if (isNaN(newPage) || newPage < 1) {
          newPage = 1; // Default to page 1 if invalid
        } else if (newPage > prevState.outBoundServiceTotalPage) {
          newPage = prevState.outBoundServiceTotalPage; // Cap at total pages
        }

        return { outBoundServiceCurrentPage: newPage };
      },
      () => {
        this.loadOutboundPageList();
      },
    );
  };

  serviceOutBoundPageClick = (e) => {
    let outBoundServiceCurrentPage = e;
    this.setState(
      {
        outBoundServiceCurrentPage: outBoundServiceCurrentPage,
      },
      () => {
        this.loadOutboundPageList();
      },
    );
  };

  refreshHandler = () => {
    let selectedNode = this.state.selectedNodeKey;
    if (selectedNode == "salesView") {
      this.executeSalesCustomer();
    } else if (selectedNode == "purchaseView") {
      this.executePurchaseVendor();
    } else if (selectedNode == "serviceView") {
      this.loadInboundPageList();
      this.loadOutboundPageList();
    } else if (selectedNode == "inventoryView") {
      this.executeInventoryList();
    }
  };
  moduleExit = () => {
    this.props.onModuleExit();
  };

  closeAlertModalCallBack = (isShowPopup) => {
    this.setState({
      isShowSalesPieChart: isShowPopup,
      isShowInventoryPieChart: isShowPopup,
      isShowAlert: isShowPopup,
      salesChartType: "",
      fabricSalesPieChartInfos: [],
      customerSalesPieChartInfos: [],
      skuSalesPieChartInfos: [],
      customerSummarySalesPieChartInfos: [],
    });
  };

  inventoryChartDatas = () => {
    let inventoryValList = [];

    let inventoryList = new Array();
    if (!isEmptyArray(this.state.inventoryList)) {
      inventoryValList = this.state.inventoryList;
      for (let list of inventoryValList) {
        let column = new ColmDef();
        column.Header = list.fabricStyleCode;
        column.accessor = list.onHandQuantity;
        inventoryList.push(column);
      }
    }
    return inventoryList;
  };

  salesChartDatas = () => {
    let salesChartType = "";
    if (!isEmptyString(this.state.salesChartType))
      salesChartType = this.state.salesChartType;
    let fabricSalesPieChartInfos = [];
    let customerSalesPieChartInfos = [];
    let skuSalesPieChartInfos = [];
    let customerSummarySalesPieChartInfos = [];
    if (salesChartType == "FabricSales") {
      let salesList = new Array();
      if (!isEmptyArray(this.state.fabricSalesPieChartInfos)) {
        fabricSalesPieChartInfos = this.state.fabricSalesPieChartInfos;
        for (let list of fabricSalesPieChartInfos) {
          let column = new ColmDef();
          column.Header = list.fabricStyleCode;
          column.accessor = list.totalSoldAmount;
          salesList.push(column);
        }
      }
      return salesList;
    } else if (salesChartType == "CustomerSales") {
      let customerList = new Array();
      if (!isEmptyArray(this.state.customerSalesPieChartInfos)) {
        customerSalesPieChartInfos = this.state.customerSalesPieChartInfos;
        for (let list of customerSalesPieChartInfos) {
          let column = new ColmDef();
          column.Header = list.customerCode;
          column.accessor = list.totalSoldAmount;
          customerList.push(column);
        }
      }
      return customerList;
    } else if (salesChartType == "SkuSales") {
      let skuList = new Array();
      if (!isEmptyArray(this.state.skuSalesPieChartInfos)) {
        skuSalesPieChartInfos = this.state.skuSalesPieChartInfos;
        for (let list of skuSalesPieChartInfos) {
          let column = new ColmDef();
          column.Header = list.fabricStyleCode;
          column.accessor = list.totalSoldAmount;
          skuList.push(column);
        }
      }
      return skuList;
    } else if (salesChartType == "customerSummarySales") {
      let customerSummaryList = new Array();
      if (!isEmptyArray(this.state.customerSummarySalesPieChartInfos)) {
        customerSummarySalesPieChartInfos =
          this.state.customerSummarySalesPieChartInfos;

        for (let list of customerSummarySalesPieChartInfos) {
          let column = new ColmDef();
          column.Header = list.customerCode;
          column.accessor = list.totalSoldAmount;
          customerSummaryList.push(column);
        }
      }
      return customerSummaryList;
    }
  };
  salesChartHandler = (e, type) => {
    this.setState({
      isShowProgressBarPopup: true,
      progressLoadingText: "Loading...",
    });
    // setTimeout(() => {
    this.getSalesChartType(type);
    // }, 100);
  };

  getSalesChartType = (type) => {
    if (type == 1) {
      this.state.salesChartType = "FabricSales";
      // console.log("getSalesChartType :", type);
      // this.setState({
      //   salesChartType: "FabricSales",
      // });

      this.loadFabricSalesAnalysis();
    } else if (type == 2) {
      this.state.salesChartType = "CustomerSales";

      this.loadCustomerSalesAnalysis();
    } else if (type == 3) {
      this.state.salesChartType = "SkuSales";

      this.loadFabricAndCustomerSalesAnalysis();
    } else if (type == 4) {
      this.state.salesChartType = "customerSummarySales";

      this.loadCustomerSummarySalesDetail();
    }
  };

  //  purchaseChartHandler = (e) => {

  //   this.setState({
  //     isShowPurchasePieChart: true,
  //   });
  // };

  inventoryChartHandler = (e) => {
    this.setState({
      isShowInventoryPieChart: true,
    });
  };

  hidePopupAlertCallBack = (msgType, isDisplayed) => {
    this.setState({ isShowPopupAlert: isDisplayed, error_list: [] });
  };
  render() {
    let fabricStyleSalesInfos = [];
    if (!isEmptyArray(this.state.fabricStyleSalesInfos))
      fabricStyleSalesInfos = this.state.fabricStyleSalesInfos;

    let inventoryList = [];
    if (!isEmptyArray(this.state.inventoryList))
      inventoryList = this.state.inventoryList;

    // console.log("fabricStyleSalesInfos ", fabricStyleSalesInfos);
    return (
      <div>
        <ProgressBar
          progressLoadingText={this.state.progressLoadingText}
          isShowPopup={this.state.isShowProgressBarPopup}
        />
        <ModuleToolBar
          isShowTitle={true}
          pageTitle={this.state.title}
          isLoading={this.state.isLoading}
          isShowExitButton={true}
          onModuleExit={() => this.moduleExit()}
          extend_toolbar={
            <>
              <Button
                className="header_buttons secondary"
                size="sm"
                // onClick={() => this.executeSalesCustomer()}
                onClick={() => this.refreshHandler()}
              >
                <REFRESHICON />
                Refresh
              </Button>
            </>
          }
        />

        {this.state.isShowNodes && (
          <BaseNodeBar
            nodeList={this.state.nodeList}
            selectedModuleKey={this.state.selectedNodeKey}
            nodeOnSelect={this.nodeOnSelect}
          />
        )}
        {!this.state.isShowNodes &&
          this.state.isSalesTab &&
          !this.state.isPurchaseTab &&
          !this.state.isInventoryTab &&
          this.getSalesView()}
        {this.state.isShowNodes &&
          this.state.isSalesTab &&
          !this.state.isPurchaseTab &&
          !this.state.isInventoryTab &&
          this.getSalesView()}
        {this.state.isShowNodes &&
          !this.state.isSalesTab &&
          this.state.isPurchaseTab &&
          !this.state.isInventoryTab &&
          this.getPurchaseView()}
        {this.state.isShowNodes &&
          !this.state.isSalesTab &&
          !this.state.isPurchaseTab &&
          this.state.isServiceTab &&
          !this.state.isInventoryTab &&
          this.getServiceView()}
        {this.state.isShowNodes &&
          !this.state.isSalesTab &&
          !this.state.isPurchaseTab &&
          !this.state.isServiceTab &&
          this.state.isInventoryTab &&
          this.getInventoryView()}

        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowFabricStyleModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowCustomerModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowInvoiceModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowVendorModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowPOModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>
        <MultiViewPopup
          isModulePopup={true}
          id="modulePopup"
          popupLvlClass={"popupSizeLevel1"}
          isShowPopup={this.state.isShowReceiptModule}
          closeModalCallBack={this.closeModalCallBack}
          module={this.state.moduleForPopup}
        ></MultiViewPopup>

        {/**************************Sales PieChart *********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowSalesPieChart}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"Chart DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hidePopupAlertCallBack}
            />
          }
          content={
            <div>
              {/* <PieChart data={this.chartDatas()} /> */}

              <PieChart
                data={this.salesChartDatas()}
                width={200}
                height={200}
                innerRadius={60}
                outerRadius={100}
              />
            </div>
          }
        />

        {/**************************Inventory Valuation PieChart *********************/}

        <MultiViewPopup
          popupLvlClass={"popupSizeLevel2"}
          isModulePopup={false}
          isShowPopup={this.state.isShowInventoryPieChart}
          closeOnEsc={false}
          closeAlertModalCallBack={this.closeAlertModalCallBack}
          title={"CHART DETAIL"}
          closeOnDocumentClick={false}
          lineFunctionalityForm={this.lineFunctionalityForm}
          lockScroll={true}
          alertContainerBox={
            <AlertToolBox
              alertMsgList={this.state.alertMessage}
              alertErrorType={this.state.alertType}
              isShowAlert={this.state.isShowPopupAlert}
              hideAlertCallBack={this.hidePopupAlertCallBack}
            />
          }
          content={
            <div>
              <PieChart
                data={this.inventoryChartDatas()}
                width={200}
                height={200}
                innerRadius={60}
                outerRadius={100}
              />
            </div>
          }
        />
      </div>
    );
  }
}
class SalesViewForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);

    this.state = {};
    this.custSaleschartRef = createRef();
    this.itemSaleschartRef = createRef();
    this.yearlySaleschartRef = createRef();
    this.lotSaleschartRef = createRef();
  }
  componentDidMount() {}

  fabricSalesColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewFabricModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfInvQty", "totalShippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalSales", "totalSoldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  customerSalesColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfInvQty", "totalShippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalSales", "totalSoldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  skuDetailColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewFabricModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "6", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "salesPersonName", true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalShipped", "totalShippedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalSales", "totalSoldAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  customerSummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Invoice", "invoiceNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewInvoiceModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("InvDate", "invoiceDate", true, false, true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "6", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewCustomerModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "customerName", true)
        .setStyleDetails("left", "7", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SalesPerson", "salesPersonCode", true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "salesPersonName", true)
        .setStyleDetails("left", "7", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SubTotal", "subTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TaxAmount", "taxAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FreightCharge", "freightChargeAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("ExtraCharge", "extraChargeAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("DiscountAmount", "discountAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };

  getDateMode = (criteria) => {
    if (criteria.dateMode == 0) {
      return (criteria.dateModeType = "MonthToDate");
    } else if (criteria.dateMode == 1) {
      return (criteria.dateModeType = "YearToDate");
    } else if (criteria.dateMode == 2) {
      return (criteria.dateModeType = "Year");
    } else if (criteria.dateMode == 3) {
      return (criteria.dateModeType = "SpecificDate");
    }
  };

  handleBarChartPDFDownload = (ref) => {
    const chartNode = ref.current;
    if (!chartNode) return;

    // ── 1. Heading / filename ─────────────────────────────────────────────────
    const headingEl = chartNode.querySelector(".analytics-heading");
    const headingText = headingEl ? headingEl.textContent.trim() : "Chart";
    const safeFileName = headingText
      .replace(/[^\w\s-]/gi, "")
      .replace(/\s+/g, "_");
    const date = new Date().toISOString().slice(0, 10);

    // ── 2. Find the D3 chart SVG (not the icon SVG inside the button) ─────────
    const allSvgs = Array.from(chartNode.querySelectorAll("svg"));

    // Filter out any SVG that is a descendant of a <button>
    const chartSvgs = allSvgs.filter((s) => !s.closest("button"));

    if (chartSvgs.length === 0) {
      console.error("No chart SVG found.");
      return;
    }

    // If somehow multiple non-button SVGs exist, take the widest one
    const svgEl = chartSvgs.reduce((best, cur) => {
      const bw = parseFloat(best.getAttribute("width") || 0);
      const cw = parseFloat(cur.getAttribute("width") || 0);
      return cw > bw ? cur : best;
    });

    const svgW =
      parseFloat(svgEl.getAttribute("width")) ||
      svgEl.getBoundingClientRect().width;
    const svgH =
      parseFloat(svgEl.getAttribute("height")) ||
      svgEl.getBoundingClientRect().height;

    if (!svgW || !svgH) {
      console.error("Could not read SVG dimensions.", svgEl);
      return;
    }

    // ── 3. Clone and prepare the SVG for standalone rendering ─────────────────
    const cloned = svgEl.cloneNode(true);
    cloned.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    cloned.setAttribute("width", svgW);
    cloned.setAttribute("height", svgH);

    // Inject a white background so the chart doesn't render on black canvas
    const bg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    bg.setAttribute("width", "100%");
    bg.setAttribute("height", "100%");
    bg.setAttribute("fill", "white");
    cloned.insertBefore(bg, cloned.firstChild);

    // ── 4. Serialize → data: URL (avoids blob: CORS restrictions) ────────────
    const svgString = new XMLSerializer().serializeToString(cloned);
    const svgDataUrl =
      "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);

    // ── 5. Off-screen canvas: heading row + chart ─────────────────────────────
    const SCALE = 2;
    const HEADING_H = 36;
    const HEADING_FS = 16;

    const canvas = document.createElement("canvas");
    canvas.width = svgW * SCALE;
    canvas.height = (svgH + HEADING_H) * SCALE;

    const ctx = canvas.getContext("2d");
    ctx.scale(SCALE, SCALE);

    // White page
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, svgW, svgH + HEADING_H);

    // Heading text
    ctx.fillStyle = "#222222";
    ctx.font = `bold ${HEADING_FS}px Arial, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText(headingText, svgW / 2, 8);

    // ── 6. Draw the chart SVG and save ───────────────────────────────────────
    const img = new Image();

    img.onload = () => {
      ctx.drawImage(img, 0, HEADING_H, svgW, svgH);

      const imgData = canvas.toDataURL("image/png");

      const totalW = svgW;
      const totalH = svgH + HEADING_H;

      const pdf = new jsPDF({
        orientation: totalW > totalH ? "landscape" : "portrait",
        unit: "pt",
        format: [totalW, totalH],
      });

      pdf.addImage(imgData, "PNG", 0, 0, totalW, totalH);
      pdf.save(`${safeFileName}_${date}.pdf`);
    };

    img.onerror = (err) => {
      console.error("SVG image load failed:", err);
    };

    img.src = svgDataUrl;
  };

  render() {
    let customerSalesDatas = [];
    if (!isEmptyArray(this.props.customerSalesDatas))
      customerSalesDatas = this.props.customerSalesDatas;
    let itemSalesDatas = this.props.itemSalesDatas;
    let yearlySalesDatas = this.props.yearlySalesDatas;
    let fabricStyleInfos = [];
    if (!isEmptyArray(this.props.fabricStyleInfos))
      fabricStyleInfos = this.props.fabricStyleInfos;

    let customerSalesInfos = [];
    if (!isEmptyArray(this.props.customerSalesInfos))
      customerSalesInfos = this.props.customerSalesInfos;

    let fabricStyleSalesInfos = [];
    if (!isEmptyArray(this.props.fabricStyleSalesInfos))
      fabricStyleSalesInfos = this.props.fabricStyleSalesInfos;

    let skuSalesInfos = [];
    if (!isEmptyArray(this.props.skuSalesInfos))
      skuSalesInfos = this.props.skuSalesInfos;

    let customerSummarySalesInfos = [];
    if (!isEmptyArray(this.props.customerSummarySalesInfos))
      customerSummarySalesInfos = this.props.customerSummarySalesInfos;

    let customerSalesChartData = null;
    if (!isEmpty(this.props.customerSalesChart))
      customerSalesChartData = this.props.customerSalesChart;

    let itemSalesChartData = null;
    if (!isEmpty(this.props.itemSalesChart))
      itemSalesChartData = this.props.itemSalesChart;

    let yearlySalesChartData = null;
    if (!isEmpty(this.props.yearlySalesChart))
      yearlySalesChartData = this.props.yearlySalesChart;

    let lotSalesChartData = null;
    if (!isEmpty(this.props.lotSalesChart))
      lotSalesChartData = this.props.lotSalesChart;

    let totalSales = null;
    let totalShippedQty = null;

    if (!isEmpty(this.props.inquiryData)) {
      totalSales = this.props.inquiryData.totalSalesAmount;
      totalShippedQty = this.props.inquiryData.totalShippedQuantity;
    }

    let criteria = this.props.salesCriteria;
    let isOpenCriteria = this.props.isOpenCriteria;

    let currencyCode = "USD";
    if (!isEmpty(ConfigManager.getCurrencyCode()))
      currencyCode = ConfigManager.getCurrencyCode();

    let uomCode = "YD";
    if (!isEmpty(ConfigManager.getUomCode()))
      uomCode = ConfigManager.getUomCode();

    this.getDateMode(criteria);
    return (
      <div>
        <div className="div_inline_justify">
          {isOpenCriteria ? (
            <div className="div_14_no_overflow_no_height analytics_sidebar_clr">
              <div className="div_inline_justify">
                <div className="div_50_no_overflow">
                  <div className="analytics-filter">Filter</div>
                </div>
                <div className="div_30_no_overflow">
                  <Button
                    className="header_buttons btn-flx"
                    size="sm"
                    onClick={(e) => this.props.executeSalesCustomer(e)}
                  >
                    <PlayIcon />
                    {""}EXECUTE
                  </Button>
                </div>
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Date</h4>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      SelectMode
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <FormControl
                      as="select"
                      custom
                      onChange={this.props.salesOnChange}
                      name="dateMode"
                      value={criteria.dateMode}
                    >
                      <option value={0}>MonthToDate</option>
                      <option value={1}>YearToDate</option>
                      <option value={2}>Year</option>
                      <option value={3}>SpecificDate</option>
                    </FormControl>
                  </Col>
                </Row>
                {this.props.isShowYearBox ? (
                  <Row className="pb-3">
                    <Col sm="12">
                      <FormLabel className="analytics-font">
                        SelectYear
                      </FormLabel>
                    </Col>
                    <Col sm="12">
                      <FormControl
                        as="select"
                        custom
                        onChange={this.props.salesOnChange}
                        name="year"
                        value={criteria.year}
                      >
                        {this.props.yearList.map((ln) => (
                          <option value={ln.year}>{ln.year}</option>
                        ))}
                      </FormControl>
                    </Col>
                  </Row>
                ) : null}
                {this.props.isShowSpecificDate ? (
                  <>
                    <Row className="d-flex justify-content-left">
                      <Col sm="12">
                        {" "}
                        <FormLabel className="analytics-font">
                          FromDate
                        </FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="startDate"
                          value={criteria.startDate}
                          onChange={this.props.salesOnChange}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-left pb-3">
                      <Col sm="12">
                        <FormLabel className="analytics-font">ToDate</FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="stopDate"
                          onChange={this.props.salesOnChange}
                          value={criteria.stopDate}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                  </>
                ) : null}
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label  pt-1">Item / Inventory</h4>

                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      FabricStyle
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleCode"
                      onChange={this.props.fabricCodeOnChange}
                      value={criteria.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.props.fabricLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.fabricEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteFabricList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteFabricList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Name
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleName"
                      onChange={this.props.salesOnChange}
                      value={criteria.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Division
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="productDivision"
                      onChange={this.props.salesOnChange}
                      value={criteria.productDivision}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Lot
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="lotNumber"
                      onChange={this.props.salesOnChange}
                      value={criteria.lotNumber}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label  pt-1">Customer</h4>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Customer
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      // ref={customerRef}
                      name="customerCode"
                      onChange={this.props.customerCodeOnChange}
                      value={criteria.customerCode}
                      lookupRequired={true}
                      lookupHandler={this.props.customerLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.customerCodeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.customerPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteCustomerList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteCustomerList
                      }
                      disabled={this.props.isDisableFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Name
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="customerName"
                      onChange={this.props.salesOnChange}
                      value={criteria.customerName}
                      disabled={true}
                    />
                  </Col>
                </Row>

                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      CustType
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="customerType"
                      onChange={this.props.salesOnChange}
                      value={criteria.customerType}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label  pt-1">SalesPerson</h4>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      SalesPerson
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      // ref={this.salesPersonRef}
                      onChange={this.props.salesPersonCodeOnChange}
                      name="salesPersonCode"
                      value={criteria.salesPersonCode}
                      lookupRequired={true}
                      lookupHandler={this.props.salesPersonLookupHandler}
                      enterKeyEventHandler={
                        this.props.salesPersonEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.salesPersonPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteSalesPersonList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteSalesPersonList
                      }
                      disabled={this.props.isDisableFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Name
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="salesPersonName"
                      onChange={this.props.salesOnChange}
                      value={criteria.salesPersonName}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>

              <div className="analytics-button">
                <Row className="d-flex justify-content-left">
                  <Col sm="6">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.executeSalesCustomer(e)}
                    >
                      <PlayIcon />
                      {""}EXECUTE
                    </Button>
                  </Col>

                  <Col sm="5">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.resetSalesCustomer(e)}
                    >
                      <UndoAlt />
                      {""}RESET
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          <div
            class={
              isOpenCriteria
                ? "div_86_no_overflow_no_height"
                : "div_100_no_overflow"
            }
          >
            <div class="div_inline">
              <div class="div_sideNav">
                <span onClick={() => this.props.closeNav()}>
                  {isOpenCriteria ? (
                    <AngleDoubleLeftIcon />
                  ) : (
                    <AngleDoubleRightIcon />
                  )}
                </span>
              </div>
              <div class="div_49_no_overflow p-1">
                <span className="analytics_header analytics-label">
                  Selected Criteria
                </span>
              </div>

              <div class="div_Equal_no_overflow p-1">
                <span className="analytics_header analytics-label">Total</span>
              </div>
            </div>

            {this.props.isSalesInquiryDatasFound && (
              <div>
                <div class="div_inline">
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-border">
                      <div class="analytics_select_criteria_panel">
                        <div className="div_inline">
                          <div className="div_Equal_no_overflow">
                            <div class="">
                              <Row class="d-flex justify-content-left">
                                <Col sm="4">
                                  <FormLabel className="analytics-label pb-1">
                                    Date:
                                  </FormLabel>
                                </Col>
                                <Col sm="8">
                                  <FormLabel className="analytics-font">
                                    {criteria.dateModeType}
                                  </FormLabel>
                                </Col>
                              </Row>
                              {this.props.isShowYearBox ? (
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    <FormLabel className="analytics-font">
                                      Year :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel className="analytics-font">
                                      {" "}
                                      {criteria.year}
                                    </FormLabel>
                                  </Col>
                                </Row>
                              ) : null}
                              {this.props.isShowSpecificDate ? (
                                <>
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        FromDate :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.startDate}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        ToDate :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.stopDate}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                </>
                              ) : null}
                            </div>

                            {!isEmptyString(criteria.fabricStyleCode) ||
                            !isEmptyString(criteria.lotNumber) ||
                            !isEmptyString(criteria.productDivision) ? (
                              <div class="">
                                {!isEmptyString(criteria.fabricStyleCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Item :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.fabricStyleCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.lotNumber) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Lot :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.lotNumber}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.productDivision) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Division :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.productDivision}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                          <div className="div_Equal_no_overflow">
                            {!isEmptyString(criteria.customerCode) ||
                            !isEmptyString(criteria.customerType) ? (
                              <div class="">
                                {!isEmptyString(criteria.customerCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        Customer:{" "}
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.customerCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.customerType) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        CustomerType:{" "}
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.customerType}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}
                              </div>
                            ) : null}

                            {!isEmptyString(criteria.salesPersonCode) ? (
                              <div class="">
                                <>
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        SalesPerson:{" "}
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.salesPersonCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>

                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      <FormLabel className="analytics-label pb-1">
                                        Name:{" "}
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.salesPersonName}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                </>
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-dashboard-value">
                      <div class="div_inline">
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalShippedQty)}
                            <span>{uomCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            Total Sales(Quantity){" "}
                          </h4>
                        </div>
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalSales)}
                            <span>{currencyCode}</span>
                          </h2>
                          <h4 class="analytics-label">Total Sales(Amount)</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="div_inline_justify_v1">
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={fabricStyleSalesInfos}
                      columns={this.fabricSalesColumns()}
                      label={"Fabric Sales Infos"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.fabricSalesExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowChartButton={true}
                      chartButtonRender={"Chart"}
                      chartButtonClickHandler={(e) =>
                        this.props.salesChartHandler(e, 1)
                      }
                      isShowPagination={true}
                      totalPages={this.props.salesAnalysisTotalPage}
                      currentPage={this.props.salesAnalysisCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadSalesAnalysisPrevious(e)
                      }
                      loadNext={(e) => this.props.loadSalesAnalysisNext(e)}
                      handleOnchange={(e) => this.props.salesInfosOnChange(e)}
                      handlePaginationOnBlur={(e) =>
                        this.props.salesInfosOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handleCustomerSalesBardChartPageClick(e)
                      }
                    />
                  </div>
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={customerSalesInfos}
                      columns={this.customerSalesColumns()}
                      label={"Customer Sales Infos"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.customerSalesExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      loadPrevious={(e) =>
                        this.props.loadCustomerSalesPrevious(e)
                      }
                      loadNext={(e) => this.props.loadCustomerSalesNext(e)}
                      currentPage={this.props.customerSalesCurrentPage}
                      totalPages={this.props.customerSalesTotalPage}
                      handleOnchange={(e) =>
                        this.props.customerSalesOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.customerSalesOnBlur(e)
                      }
                      onPageClick={(e) => this.props.customerSalesOnClick(e)}
                      isShowChartButton={true}
                      chartButtonRender={"Chart"}
                      chartButtonClickHandler={(e) =>
                        this.props.salesChartHandler(e, 2)
                      }
                      //enableVritualizer = {true}
                    />
                  </div>

                  <div></div>
                </div>
                <div className="div_inline_justify_v1">
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={skuSalesInfos}
                      columns={this.skuDetailColumns()}
                      label={"SKU Details Report"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.skuDetailExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      loadPrevious={(e) => this.props.loadSkuDetailPrevious(e)}
                      loadNext={(e) => this.props.loadSkuDetailNext(e)}
                      currentPage={this.props.skuDetailsCurrentPage}
                      totalPages={this.props.skuDetailsTotalPage}
                      handleOnchange={(e) => this.props.skuDetailsOnChange(e)}
                      handlePaginationOnBlur={(e) =>
                        this.props.skuDetailsSalesOnBlur(e)
                      }
                      onPageClick={(e) => this.props.skuDetailsSalesOnClick(e)}
                      isShowChartButton={true}
                      chartButtonRender={"Chart"}
                      chartButtonClickHandler={(e) =>
                        this.props.salesChartHandler(e, 3)
                      }
                    />
                  </div>
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={customerSummarySalesInfos}
                      columns={this.customerSummaryColumns()}
                      label={"Total Sales Report"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.customerSummaryExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      loadPrevious={(e) => this.props.loadSalesTotalPrevious(e)}
                      loadNext={(e) => this.props.loadSalesTotalNext(e)}
                      currentPage={this.props.salesTotalCurrentPage}
                      totalPages={this.props.salesTotalPage}
                      handleOnchange={(e) => this.props.salesTotalOnChange(e)}
                      handlePaginationOnBlur={(e) =>
                        this.props.salesTotalOnBlur(e)
                      }
                      onPageClick={(e) => this.props.salesTotalOnClick(e)}
                      isShowChartButton={true}
                      chartButtonRender={"Chart"}
                      chartButtonClickHandler={(e) =>
                        this.props.salesChartHandler(e, 4)
                      }
                    />
                  </div>
                </div>
                <div class="analytics-dashboard-container">
                  <div ref={this.custSaleschartRef}>
                    <h2 class="analytics-heading">Customer Sales</h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(this.custSaleschartRef)
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    <div>
                      {customerSalesChartData ? (
                        <BarChart
                          data={customerSalesChartData}
                          width={800}
                          height={350}
                          legendTitle="Customer Sales"
                          isShowPagination={true}
                          totalPages={
                            this.props.customerSalesBardChartTotalPage
                          }
                          currentPage={
                            this.props.customerSalesBarChartCurrentPage
                          }
                          loadPrevious={(e) =>
                            this.props.loadCustomerBarChartPrevious(e)
                          }
                          loadNext={(e) =>
                            this.props.loadCustomerBarChartNext(e)
                          }
                          handleOnchange={(e) =>
                            this.props.handleCustomerBarChartOnChange(e)
                          }
                          handlePaginationOnBlur={(e) =>
                            this.props.handleCustomerBarChartPaginationOnBlur(e)
                          }
                          onPageClick={(e) =>
                            this.props.handleCustomerBarChartPageClick(e)
                          }
                        />
                      ) : (
                        <div className="no_Data_small">NO DATA</div>
                      )}
                    </div>
                  </div>

                  <div ref={this.itemSaleschartRef}>
                    <h2 class="analytics-heading">Item Sales</h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(this.itemSaleschartRef)
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    <div>
                      {itemSalesChartData ? (
                        <BarChart
                          data={itemSalesChartData}
                          width={800}
                          height={350}
                          legendTitle="Item Sales"
                          isShowPagination={true}
                          totalPages={this.props.itemSalesBardChartTotalPage}
                          currentPage={this.props.itemSalesBarChartCurrentPage}
                          loadPrevious={(e) =>
                            this.props.loadItemBarChartPrevious(e)
                          }
                          loadNext={(e) =>
                            this.props.loadItemSalesBarChartNext(e)
                          }
                          handleOnchange={(e) =>
                            this.props.handleItemSalesBarChartOnChange(e)
                          }
                          handlePaginationOnBlur={(e) =>
                            this.props.handleItemSalesBarChartPaginationOnBlur(
                              e,
                            )
                          }
                          onPageClick={(e) =>
                            this.props.handleItemSalesBarChartPageClick(e)
                          }
                        />
                      ) : (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                  </div>
                </div>
                <div class="analytics-dashboard-container">
                  <div ref={this.yearlySaleschartRef}>
                    <h2 class="analytics-heading">Yearly Sales </h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(this.yearlySaleschartRef)
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    <div>
                      {yearlySalesChartData ? (
                        <BarChart
                          data={yearlySalesChartData}
                          width={800}
                          height={350}
                          legendTitle="Yearly Sales"
                          isShowPagination={true}
                          totalPages={this.props.yearlyBardChartTotalPage}
                          currentPage={this.props.yearlyBarChartCurrentPage}
                          loadPrevious={(e) =>
                            this.props.loadYearlyBarChartPrevious(e)
                          }
                          loadNext={(e) => this.props.loadYearlyBarChartNext(e)}
                          handleOnchange={(e) =>
                            this.props.handleYearlyBarChartOnChange(e)
                          }
                          handlePaginationOnBlur={(e) =>
                            this.props.handleYearlyBarChartPaginationOnBlur(e)
                          }
                          onPageClick={(e) =>
                            this.props.handleYearlyBarChartPageClick(e)
                          }
                        />
                      ) : (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                  </div>
                  <div ref={this.lotSaleschartRef}>
                    <h2 class="analytics-heading">Lot Sales</h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(this.lotSaleschartRef)
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    <div>
                      {lotSalesChartData ? (
                        <BarChart
                          data={lotSalesChartData}
                          width={800}
                          height={350}
                          legendTitle="Lot Sales"
                          isShowPagination={true}
                          totalPages={this.props.lotSalesBardChartTotalPage}
                          currentPage={this.props.lotSalesBarChartCurrentPage}
                          loadPrevious={(e) =>
                            this.props.loadLotSalesBarChartPrevious(e)
                          }
                          loadNext={(e) =>
                            this.props.loadLotSalesBarChartNext(e)
                          }
                          handleOnchange={(e) =>
                            this.props.handleLotSalesBarChartOnChange(e)
                          }
                          handlePaginationOnBlur={(e) =>
                            this.props.handleLotSalesBarChartPaginationOnBlur(e)
                          }
                          onPageClick={(e) =>
                            this.props.handleLotSalesBarChartPageClick(e)
                          }
                        />
                      ) : (
                        <div className="no_Data_small">{"NO DATA"}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}
class PurchaseViewForm extends React.Component {
  static contextType = AppContext;
  constructor(props) {
    super(props);
    this.state = {};
    this.vendorPurchaseChartRef = createRef();
    this.itemPurchaseChartRef = createRef();
    this.yearlyPurchaseChartRef = createRef();
    this.lotPurchaseChartRef = createRef();
  }
  componentDidMount() {}

  fabricPurchaseColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle#", "fabricStyleCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewFabricModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfPOQty", "totalOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfReceiptQty", "totalReceivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalPurchase", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  vendorPurchaseColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewVendorModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfPOQty", "totalOrderQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SumOfReceiptQty", "totalReceivedQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalSales", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  skuDetailColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewPOModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "entityDate", true, false, true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewVendorModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewFabricModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Lot", "lotNumber", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ReceivedQty", "receiptReceivedQty", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("OrderQty", "purchaseOrderQty", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Total", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  vendorSummaryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("PO#", "purchaseOrderNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewPOModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Date", "ordereDate", true, false, true)
        .setStyleDetails("left", "6", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Receipt#", "purchaseOrderReceiptNumber", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewPRModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Vendor", "vendorCode", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3")
        .setClickDetails(true, false, this.props.viewVendorModule, null),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "vendorName", true)
        .setStyleDetails("left", "4", "", "wt-3", "wt-3"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SubTotal", "subTotalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TaxAmount", "taxAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ExtraCharge", "extraChargeAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("DiscountAmount", "discountAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Total", "totalAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };

  getDateMode = (criteria) => {
    if (criteria.dateMode == 0) {
      return (criteria.dateModeType = "MonthToDate");
    } else if (criteria.dateMode == 1) {
      return (criteria.dateModeType = "YearToDate");
    } else if (criteria.dateMode == 2) {
      return (criteria.dateModeType = "Year");
    } else if (criteria.dateMode == 3) {
      return (criteria.dateModeType = "SpecificDate");
    }
  };

  handleBarChartPDFDownload = (ref) => {
    const chartNode = ref.current;
    if (!chartNode) return;

    // ── 1. Heading / filename ─────────────────────────────────────────────────
    const headingEl = chartNode.querySelector(".analytics-heading");
    const headingText = headingEl ? headingEl.textContent.trim() : "Chart";
    const safeFileName = headingText
      .replace(/[^\w\s-]/gi, "")
      .replace(/\s+/g, "_");
    const date = new Date().toISOString().slice(0, 10);

    // ── 2. Find the D3 chart SVG (not the icon SVG inside the button) ─────────
    const allSvgs = Array.from(chartNode.querySelectorAll("svg"));

    // Filter out any SVG that is a descendant of a <button>
    const chartSvgs = allSvgs.filter((s) => !s.closest("button"));

    if (chartSvgs.length === 0) {
      console.error("No chart SVG found.");
      return;
    }

    // If somehow multiple non-button SVGs exist, take the widest one
    const svgEl = chartSvgs.reduce((best, cur) => {
      const bw = parseFloat(best.getAttribute("width") || 0);
      const cw = parseFloat(cur.getAttribute("width") || 0);
      return cw > bw ? cur : best;
    });

    const svgW =
      parseFloat(svgEl.getAttribute("width")) ||
      svgEl.getBoundingClientRect().width;
    const svgH =
      parseFloat(svgEl.getAttribute("height")) ||
      svgEl.getBoundingClientRect().height;

    if (!svgW || !svgH) {
      console.error("Could not read SVG dimensions.", svgEl);
      return;
    }

    // ── 3. Clone and prepare the SVG for standalone rendering ─────────────────
    const cloned = svgEl.cloneNode(true);
    cloned.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    cloned.setAttribute("width", svgW);
    cloned.setAttribute("height", svgH);

    // Inject a white background so the chart doesn't render on black canvas
    const bg = document.createElementNS("http://www.w3.org/2000/svg", "rect");
    bg.setAttribute("width", "100%");
    bg.setAttribute("height", "100%");
    bg.setAttribute("fill", "white");
    cloned.insertBefore(bg, cloned.firstChild);

    // ── 4. Serialize → data: URL (avoids blob: CORS restrictions) ────────────
    const svgString = new XMLSerializer().serializeToString(cloned);
    const svgDataUrl =
      "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgString);

    // ── 5. Off-screen canvas: heading row + chart ─────────────────────────────
    const SCALE = 2;
    const HEADING_H = 36;
    const HEADING_FS = 16;

    const canvas = document.createElement("canvas");
    canvas.width = svgW * SCALE;
    canvas.height = (svgH + HEADING_H) * SCALE;

    const ctx = canvas.getContext("2d");
    ctx.scale(SCALE, SCALE);

    // White page
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, svgW, svgH + HEADING_H);

    // Heading text
    ctx.fillStyle = "#222222";
    ctx.font = `bold ${HEADING_FS}px Arial, sans-serif`;
    ctx.textAlign = "center";
    ctx.textBaseline = "top";
    ctx.fillText(headingText, svgW / 2, 8);

    // ── 6. Draw the chart SVG and save ───────────────────────────────────────
    const img = new Image();

    img.onload = () => {
      ctx.drawImage(img, 0, HEADING_H, svgW, svgH);

      const imgData = canvas.toDataURL("image/png");

      const totalW = svgW;
      const totalH = svgH + HEADING_H;

      const pdf = new jsPDF({
        orientation: totalW > totalH ? "landscape" : "portrait",
        unit: "pt",
        format: [totalW, totalH],
      });

      pdf.addImage(imgData, "PNG", 0, 0, totalW, totalH);
      pdf.save(`${safeFileName}_${date}.pdf`);
    };

    img.onerror = (err) => {
      console.error("SVG image load failed:", err);
    };

    img.src = svgDataUrl;
  };

  render() {
    let customerSalesDatas = [];
    if (!isEmptyArray(this.props.customerSalesDatas))
      customerSalesDatas = this.props.customerSalesDatas;
    let itemSalesDatas = this.props.itemSalesDatas;
    let yearlySalesDatas = this.props.yearlySalesDatas;
    let fabricStyleInfos = [];

    let vendorPurchaseInfos = [];
    if (!isEmptyArray(this.props.vendorPurchaseInfos))
      vendorPurchaseInfos = this.props.vendorPurchaseInfos;

    let fabricStylePurchaseInfos = [];
    if (!isEmptyArray(this.props.fabricStylePurchaseInfos))
      fabricStylePurchaseInfos = this.props.fabricStylePurchaseInfos;

    let skuPurchaseInfos = [];
    if (!isEmptyArray(this.props.skuPurchaseInfos))
      skuPurchaseInfos = this.props.skuPurchaseInfos;

    let vendorSummaryPurchaseInfos = [];
    if (!isEmptyArray(this.props.vendorSummaryPurchaseInfos))
      vendorSummaryPurchaseInfos = this.props.vendorSummaryPurchaseInfos;

    let vendorPurchaseChartData = null;
    if (!isEmpty(this.props.vendorPurchaseChart))
      vendorPurchaseChartData = this.props.vendorPurchaseChart;

    let itemPurchaseChartData = null;
    if (!isEmpty(this.props.itemPurchaseChart))
      itemPurchaseChartData = this.props.itemPurchaseChart;
    let yearlyPurchaseChartData = null;
    if (!isEmpty(this.props.yearlyPurchaseChart))
      yearlyPurchaseChartData = this.props.yearlyPurchaseChart;

    let lotPurchaseChartData = null;
    if (!isEmpty(this.props.lotPurchaseChart))
      lotPurchaseChartData = this.props.lotPurchaseChart;

    console.log("lotPurchaseChartData", lotPurchaseChartData);

    let totalPurchase = null;
    let totalShippedQty = null;

    if (!isEmpty(this.props.inquiryData)) {
      totalPurchase = this.props.inquiryData.totalReceivedAmount;
      totalShippedQty = this.props.inquiryData.totalReceivedQty;
    }

    let criteria = this.props.salesCriteria;
    let isOpenCriteria = this.props.isOpenCriteria;

    let currencyCode = "USD";
    if (!isEmpty(ConfigManager.getCurrencyCode()))
      currencyCode = ConfigManager.getCurrencyCode();

    let uomCode = "YD";
    if (!isEmpty(ConfigManager.getUomCode()))
      uomCode = ConfigManager.getUomCode();

    this.getDateMode(criteria);
    return (
      <div>
        <div>{/* <h2 class="analytics-label">Selected Criteria</h2> */}</div>
        <div className="div_inline_justify">
          {isOpenCriteria ? (
            <div className="div_14_no_overflow_no_height  analytics_sidebar_clr">
              <div className="div_inline_justify">
                <div className="div_50_no_overflow">
                  <div className="analytics-filter">Filter</div>
                </div>
                <div className="div_30_no_overflow">
                  <Button
                    className="header_buttons btn-flx"
                    size="sm"
                    onClick={(e) => this.props.executePurchaseVendor(e)}
                  >
                    <PlayIcon />
                    {""}EXECUTE
                  </Button>
                </div>
              </div>
              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Date</h4>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font">SelectMode</FormLabel>
                  </Col>
                  <Col sm="12">
                    <FormControl
                      as="select"
                      custom
                      onChange={this.props.salesOnChange}
                      name="dateMode"
                      value={criteria.dateMode}
                    >
                      <option value={0}>MonthToDate</option>
                      <option value={1}>YearToDate</option>
                      <option value={2}>Year</option>
                      <option value={3}>SpecificDate</option>
                    </FormControl>
                  </Col>
                </Row>
                {this.props.isShowYearBox ? (
                  <Row class="pb-3">
                    <Col sm="12">
                      <FormLabel className="analytics-font">
                        SelectYear
                      </FormLabel>
                    </Col>
                    <Col sm="12">
                      <FormControl
                        as="select"
                        custom
                        onChange={this.props.salesOnChange}
                        name="year"
                        value={criteria.year}
                      >
                        {this.props.yearList.map((ln) => (
                          <option value={ln.year}>{ln.year}</option>
                        ))}
                      </FormControl>
                    </Col>
                  </Row>
                ) : null}
                {this.props.isShowSpecificDate ? (
                  <>
                    <Row className="d-flex justify-content-left">
                      <Col sm="12">
                        {" "}
                        <FormLabel className="analytics-font">
                          FromDate
                        </FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="startDate"
                          value={criteria.startDate}
                          onChange={this.props.salesOnChange}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-left pb-3">
                      <Col sm="12">
                        <FormLabel className="analytics-font">ToDate</FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="stopDate"
                          onChange={this.props.salesOnChange}
                          value={criteria.stopDate}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                  </>
                ) : null}
              </div>
              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Item/Inventory</h4>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">
                      FabricStyle
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleCode"
                      onChange={this.props.fabricCodeOnChange}
                      value={criteria.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.props.fabricLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.fabricEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteFabricList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteFabricList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Name</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleName"
                      onChange={this.props.salesOnChange}
                      value={criteria.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Lot</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="lotNumber"
                      onChange={this.props.salesOnChange}
                      value={criteria.lotNumber}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Division</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="productDivision"
                      onChange={this.props.salesOnChange}
                      value={criteria.productDivision}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Vendor</h4>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Vendor</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      // ref={customerRef}
                      name="vendorCode"
                      onChange={this.props.vendorCodeOnChange}
                      value={criteria.vendorCode}
                      lookupRequired={true}
                      lookupHandler={this.props.vendorLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.vendorCodeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.vendorPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteVendorList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteVendorList
                      }
                      disabled={this.props.isDisableFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Name</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="vendorName"
                      onChange={this.props.salesOnChange}
                      value={criteria.vendorName}
                      disabled={true}
                    />
                  </Col>
                </Row>
              </div>

              <div className="analytics-button">
                <Row className="d-flex justify-content-left">
                  <Col sm="6">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.executePurchaseVendor(e)}
                    >
                      <PlayIcon />
                      {""}EXECUTE
                    </Button>
                  </Col>

                  <Col sm="5">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.resetPurchaseVendor(e)}
                    >
                      <UndoAlt />
                      {""}RESET
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          <div
            class={
              isOpenCriteria
                ? "div_86_no_overflow_no_height"
                : "div_100_no_overflow"
            }
          >
            {/* <div class="div_70_no_overflow"> */}

            <div class="div_inline">
              <div class="div_sideNav">
                <span onClick={() => this.props.closeNav()}>
                  {isOpenCriteria ? (
                    <AngleDoubleLeftIcon />
                  ) : (
                    <AngleDoubleRightIcon />
                  )}
                </span>
              </div>
              <div class="div_49_no_overflow p-1">
                <span className="analytics_header analytics-label">
                  Selected Criteria
                </span>
              </div>

              <div class="div_Equal_no_overflow p-1">
                <span className="analytics_header analytics-label">Total</span>
              </div>
            </div>

            {this.props.isPurchaseInquiryDatasFound && (
              <div>
                <div class="div_inline">
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-border">
                      <div class="analytics_select_criteria_panel">
                        <div className="div_inline">
                          <div className="div_Equal_no_overflow">
                            <Row class="d-flex justify-content-left">
                              <Col sm="4">
                                <FormLabel className="analytics-label pb-1">
                                  Date :
                                </FormLabel>
                              </Col>
                              <Col sm="8">
                                <FormLabel className="analytics-font">
                                  {criteria.dateModeType}
                                </FormLabel>
                              </Col>
                            </Row>
                            {this.props.isShowYearBox ? (
                              <Row class="d-flex justify-content-left">
                                <Col sm="4">
                                  <FormLabel className="analytics-label pb-1">
                                    Year :
                                  </FormLabel>
                                </Col>
                                <Col sm="8">
                                  <FormLabel className="analytics-font">
                                    {criteria.year}
                                  </FormLabel>
                                </Col>
                              </Row>
                            ) : null}
                            {this.props.isShowSpecificDate ? (
                              <>
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    <FormLabel className="analytics-label pb-1">
                                      FromDate :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel>{criteria.startDate}</FormLabel>
                                  </Col>
                                </Row>
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    <FormLabel className="analytics-label pb-1">
                                      ToDate :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel className="analytics-font">
                                      {criteria.stopDate}
                                    </FormLabel>
                                  </Col>
                                </Row>
                              </>
                            ) : null}

                            {!isEmptyString(criteria.fabricStyleCode) ||
                            !isEmptyString(criteria.lotNumber) ||
                            !isEmptyString(criteria.productDivision) ? (
                              <div class="">
                                {!isEmptyString(criteria.fabricStyleCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Item :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-label pb-1">
                                        {criteria.fabricStyleCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}
                                {!isEmptyString(criteria.lotNumber) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Lot :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.lotNumber}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.productDivision) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Division :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.productDivision}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                          {!isEmptyString(criteria.vendorCode) ? (
                            <div className="div_Equal_no_overflow">
                              <Row class="d-flex justify-content-left">
                                <Col sm="4">
                                  <FormLabel className="analytics-label pb-1">
                                    Vendor :
                                  </FormLabel>
                                </Col>
                                <Col sm="8">
                                  <FormLabel className="analytics-font">
                                    {criteria.vendorCode}
                                  </FormLabel>
                                </Col>
                              </Row>

                              <Row class="d-flex justify-content-left">
                                <Col sm="4">
                                  <FormLabel className="analytics-label pb-1">
                                    Name :
                                  </FormLabel>
                                </Col>
                                <Col sm="8">
                                  <FormLabel className="analytics-font">
                                    {criteria.vendorName}
                                  </FormLabel>
                                </Col>
                              </Row>
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-dashboard-value">
                      <div class="div_inline">
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalShippedQty)}
                            <span>{uomCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            Total Purchase(Quantity){" "}
                          </h4>
                        </div>
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalPurchase)}
                            <span>{currencyCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            Total Purchase(Amount)
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="div_inline_justify">
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={fabricStylePurchaseInfos}
                      columns={this.fabricPurchaseColumns()}
                      label={"Fabric Purchase Infos"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.fabricPurchaseInfoexcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      totalPages={this.props.fabricPurchaseTotalPage}
                      currentPage={this.props.fabricPurchaseCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadFabricPurchasePrevious(e)
                      }
                      loadNext={(e) => this.props.loadFabricPurchaseNext(e)}
                      handleOnchange={(e) =>
                        this.props.fabricPurchaseOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.fabricPurchaseOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handleFabricPurchasePageClick(e)
                      }
                    />
                  </div>
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={vendorPurchaseInfos}
                      columns={this.vendorPurchaseColumns()}
                      label={"Vendor Purchase Infos"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.vendorPurchaseInfoExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      totalPages={this.props.vendorPurchaseTotalPage}
                      currentPage={this.props.vendorPurchaseCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadVendorPurchasePrevious(e)
                      }
                      loadNext={(e) => this.props.loadVendorPurchaseNext(e)}
                      handleOnchange={(e) =>
                        this.props.vendorPurchaseOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.vendorPurchaseOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handleVendorPurchasePageClick(e)
                      }
                    />
                  </div>

                  <div></div>
                </div>
                <div className="div_inline_justify">
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={skuPurchaseInfos}
                      columns={this.skuDetailColumns()}
                      label={"SKU Details Report"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.skuDetailPOExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      totalPages={this.props.fabricVendor_PurchaseTotalPage}
                      currentPage={this.props.fabricvendor_PurchaseCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadFabricVendor_PurchasePrevious(e)
                      }
                      loadNext={(e) =>
                        this.props.loadFabricVendor_PurchaseNext(e)
                      }
                      handleOnchange={(e) =>
                        this.props.fabricVendor_PurchaseOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.fabricVendor_PurchaseOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handlefabricVendor_PurchasePageClick(e)
                      }
                    />
                  </div>
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={vendorSummaryPurchaseInfos}
                      columns={this.vendorSummaryColumns()}
                      label={"Total Purchase Report"}
                      cstmStyle="custom_style"
                      isShowLabelButton={true}
                      labelButtonClickHandler={(e) =>
                        this.props.vendorSummaryPOExcelHandler(e)
                      }
                      labelButtonRender={"Excel"}
                      isShowPagination={true}
                      totalPages={this.props.vendorSummaryPurchaseTotalPage}
                      currentPage={this.props.vendorSummaryPurchaseCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadVendorSummaryPurchasePrevious(e)
                      }
                      loadNext={(e) =>
                        this.props.loadVendorSummaryPurchaseNext(e)
                      }
                      handleOnchange={(e) =>
                        this.props.vendorSummaryPurchaseOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.vendorSummaryVendorPurchaseOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handleVendorSummaryPurchasePageClick(e)
                      }
                    />
                  </div>

                  <div></div>
                </div>
                <div class="analytics-dashboard-container">
                  <div ref={this.vendorPurchaseChartRef}>
                    <h2 class="analytics-heading">Vendor Purchase </h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(
                          this.vendorPurchaseChartRef,
                        )
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    {vendorPurchaseChartData ? (
                      <BarChart
                        data={vendorPurchaseChartData}
                        width={800}
                        height={350}
                        legendTitle="Customer Purchase"
                        isShowPagination={true}
                        totalPages={this.props.vendorPurchaseBarChartTotalPage}
                        currentPage={
                          this.props.vendorPurchaseBarChartCurrentPage
                        }
                        loadPrevious={(e) =>
                          this.props.loadVendorPurchaseBarChartPrevious(e)
                        }
                        loadNext={(e) =>
                          this.props.loadVendorPurchaseBarChartNext(e)
                        }
                        handleOnchange={(e) =>
                          this.props.handleVendorPurchaseBarChartOnChange(e)
                        }
                        handlePaginationOnBlur={(e) =>
                          this.props.handleVendorPurchaseBarChartPaginationOnBlur(
                            e,
                          )
                        }
                        onPageClick={(e) =>
                          this.props.handleVendorPurchaseBarChartPageClick(e)
                        }
                      />
                    ) : (
                      <div className="no_Data_small">{"NO DATA"}</div>
                    )}
                  </div>
                  <div ref={this.itemPurchaseChartRef}>
                    <h2 class="analytics-heading">Item Purchase</h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(
                          this.itemPurchaseChartRef,
                        )
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    {itemPurchaseChartData ? (
                      <BarChart
                        data={itemPurchaseChartData}
                        width={800}
                        height={350}
                        legendTitle="Item Purchase"
                        isShowPagination={true}
                        totalPages={this.props.itemPurchaseBarChartTotalPage}
                        currentPage={this.props.itemPurchaseBarChartCurrentPage}
                        loadPrevious={(e) =>
                          this.props.loadItemPurchaseBarChartPrevious(e)
                        }
                        loadNext={(e) =>
                          this.props.loadItemPurchaseBarChartNext(e)
                        }
                        handleOnchange={(e) =>
                          this.props.handleItemPurchaseBarChartOnChange(e)
                        }
                        handlePaginationOnBlur={(e) =>
                          this.props.handleItemPurchaseBarChartPaginationOnBlur(
                            e,
                          )
                        }
                        onPageClick={(e) =>
                          this.props.handleItemPurchaseBarChartPageClick(e)
                        }
                      />
                    ) : (
                      <div className="no_Data_small">{"NO DATA"}</div>
                    )}
                  </div>
                </div>
                <div class="analytics-dashboard-container">
                  <div ref={this.yearlyPurchaseChartRef}>
                    <h2 class="analytics-heading">Yearly Purchase </h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(
                          this.yearlyPurchaseChartRef,
                        )
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    {yearlyPurchaseChartData ? (
                      <BarChart
                        data={yearlyPurchaseChartData}
                        width={800}
                        height={350}
                        legendTitle="Yearly Purchase"
                        isShowPagination={true}
                        totalPages={this.props.yearlyPurchaseBarChartTotalPage}
                        currentPage={
                          this.props.yearlyPurchaseBarChartCurrentPage
                        }
                        loadPrevious={(e) =>
                          this.props.loadYearlyPurchaseBarChartPrevious(e)
                        }
                        loadNext={(e) =>
                          this.props.loadYearlyPurchaseBarChartNext(e)
                        }
                        handleOnchange={(e) =>
                          this.props.handleYearlyPurchaseBarChartOnChange(e)
                        }
                        handlePaginationOnBlur={(e) =>
                          this.props.handleYearlyPurchaseBarChartPaginationOnBlur(
                            e,
                          )
                        }
                        onPageClick={(e) =>
                          this.props.handleYearlyPurchaseBarChartPageClick(e)
                        }
                      />
                    ) : (
                      <div className="no_Data_small">{"NO DATA"}</div>
                    )}
                  </div>
                  <div ref={this.lotPurchaseChartRef}>
                    <h2 class="analytics-heading">Lot Purchase</h2>
                    <button
                      className="pdf-ignore"
                      onClick={() =>
                        this.handleBarChartPDFDownload(this.lotPurchaseChartRef)
                      }
                    >
                      <PDFIcon />
                      {""}PDF
                    </button>
                    {lotPurchaseChartData ? (
                      <BarChart
                        data={lotPurchaseChartData}
                        width={800}
                        height={350}
                        legendTitle="Lot Purchase"
                        isShowPagination={true}
                        totalPages={this.props.lotPurchaseBarChartTotalPage}
                        currentPage={this.props.lotPurchaseBarChartCurrentPage}
                        loadPrevious={(e) =>
                          this.props.loadLotPurchaseBarChartPrevious(e)
                        }
                        loadNext={(e) =>
                          this.props.loadLotPurchaseBarChartNext(e)
                        }
                        handleOnchange={(e) =>
                          this.props.handleLotPurchaseBarChartOnChange(e)
                        }
                        handlePaginationOnBlur={(e) =>
                          this.props.handleLotPurchaseBarChartPaginationOnBlur(
                            e,
                          )
                        }
                        onPageClick={(e) =>
                          this.props.handleLotPurchaseBarChartPageClick(e)
                        }
                      />
                    ) : (
                      <div className="no_Data_small">{"NO DATA"}</div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class ServiceViewForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
  }

  getDateMode = (criteria) => {
    if (criteria.dateMode == 0) {
      return (criteria.dateModeType = "MonthToDate");
    } else if (criteria.dateMode == 1) {
      return (criteria.dateModeType = "YearToDate");
    } else if (criteria.dateMode == 2) {
      return (criteria.dateModeType = "Year");
    } else if (criteria.dateMode == 3) {
      return (criteria.dateModeType = "SpecificDate");
    }
  };

  inboundServiceColumns = () => {
    const columns = new Array();

    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewCustomerModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Service", "serviceCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ServiceName", "serviceName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("InoundOrder", "logisticOrderNumber", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("InoundOrderReceipt", "logisticOrderReceiptNumber", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalServiceAmount", "totalServiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  outboundServiceColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("Customer", "customerCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewCustomerModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("CustomerName", "customerName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Service", "serviceCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("ServiceName", "serviceName", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("SO#", "salesOrderNumber", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("PT#", "pickTicketNumber", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("TotalServiceAmount", "totalServiceAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4"),
    );

    return columns;
  };
  render() {
    let inboundServiceList = [];
    if (!isEmptyArray(this.props.inboundServiceList))
      inboundServiceList = this.props.inboundServiceList;

    let outboundServiceList = [];
    if (!isEmptyArray(this.props.outboundServiceList))
      outboundServiceList = this.props.outboundServiceList;

    let currencyCode = "USD";
    if (!isEmpty(ConfigManager.getCurrencyCode()))
      currencyCode = ConfigManager.getCurrencyCode();

    let totalPurchase = null;
    let totalShippedQty = null;

    if (!isEmpty(this.props.inquiryData)) {
      totalPurchase = this.props.inquiryData.totalReceivedAmount;
      totalShippedQty = this.props.inquiryData.totalReceivedQty;
    }
    let uomCode = "YD";
    if (!isEmpty(ConfigManager.getUomCode()))
      uomCode = ConfigManager.getUomCode();
    let criteria = this.props.salesCriteria;
    this.getDateMode(criteria);
    let isOpenCriteria = this.props.isOpenCriteria;

    let isServiceInquiryDataFound = this.props.isServiceInquiryDataFound;
    return (
      <div>
        <div className="div_inline_justify">
          {isOpenCriteria ? (
            <div className="div_14_no_overflow_no_height analytics_sidebar_clr">
              <div className="div_inline_justify">
                <div className="div_50_no_overflow">
                  <div className="analytics-filter">Filter</div>
                </div>
                <div className="div_30_no_overflow">
                  <Button
                    className="header_buttons btn-flx"
                    size="sm"
                    onClick={(e) => this.props.executeServiceList(e)}
                  >
                    <PlayIcon />
                    {""}EXECUTE
                  </Button>
                </div>
              </div>
              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Date</h4>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font">SelectMode</FormLabel>
                  </Col>
                  <Col sm="12">
                    <FormControl
                      as="select"
                      custom
                      onChange={this.props.salesOnChange}
                      name="dateMode"
                      value={criteria.dateMode}
                    >
                      <option value={0}>MonthToDate</option>
                      <option value={1}>YearToDate</option>
                      <option value={2}>Year</option>
                      <option value={3}>SpecificDate</option>
                    </FormControl>
                  </Col>
                </Row>
                {this.props.isShowYearBox ? (
                  <Row class="pb-3">
                    <Col sm="12">
                      <FormLabel className="analytics-font">
                        SelectYear
                      </FormLabel>
                    </Col>
                    <Col sm="12">
                      <FormControl
                        as="select"
                        custom
                        onChange={this.props.salesOnChange}
                        name="year"
                        value={criteria.year}
                      >
                        {this.props.yearList.map((ln) => (
                          <option value={ln.year}>{ln.year}</option>
                        ))}
                      </FormControl>
                    </Col>
                  </Row>
                ) : null}
                {this.props.isShowSpecificDate ? (
                  <>
                    <Row className="d-flex justify-content-left">
                      <Col sm="12">
                        {" "}
                        <FormLabel className="analytics-font">
                          FromDate
                        </FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="startDate"
                          value={criteria.startDate}
                          onChange={this.props.salesOnChange}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                    <Row className="d-flex justify-content-left pb-3">
                      <Col sm="12">
                        <FormLabel className="analytics-font">ToDate</FormLabel>
                      </Col>
                      <Col sm="12">
                        <DatePickerComponent
                          name="stopDate"
                          onChange={this.props.salesOnChange}
                          value={criteria.stopDate}
                          disabled={this.props.isDisableFields}
                        />
                      </Col>
                    </Row>
                  </>
                ) : null}
              </div>
              <div class="div_criteria_panel">
                <h4 class="analytics-label pt-1">Inbound/Outbound</h4>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Customer</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="customerCode"
                      onChange={this.props.customerCodeOnChange}
                      value={criteria.customerCode}
                      lookupRequired={true}
                      lookupHandler={this.props.customerLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.customerCodeEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.customerPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteCustomerList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteCustomerList
                      }
                      disabled={this.props.isDisableFields}
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Name</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="customerName"
                      onChange={this.props.salesOnChange}
                      value={criteria.customerName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font">Service</FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="serviceCode"
                      onChange={this.props.serviceOnChange}
                      value={criteria.serviceCode}
                      lookupRequired={true}
                      lookupHandler={this.props.serviceLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={this.props.serviceEnterKeyEvent}
                      autoCompleteListData={
                        this.props.servicePageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayServiceAutoCompleteList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteServiceList
                      }
                      isMandatory={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font">
                      ServiceName
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="serviceName"
                      onChange={this.props.salesOnChange}
                      value={criteria.serviceName}
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
              </div>

              <div className="analytics-button">
                <Row className="d-flex justify-content-left">
                  <Col sm="6">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.executeServiceList(e)}
                    >
                      <PlayIcon />
                      {""}EXECUTE
                    </Button>
                  </Col>

                  <Col sm="5">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.resetServiceList(e)}
                    >
                      <UndoAlt />
                      {""}RESET
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          <div
            class={
              isOpenCriteria
                ? "div_86_no_overflow_no_height"
                : "div_100_no_overflow"
            }
          >
            {/* <div class="div_70_no_overflow"> */}

            <div class="div_inline">
              <div class="div_sideNav">
                <span onClick={() => this.props.closeNav()}>
                  {isOpenCriteria ? (
                    <AngleDoubleLeftIcon />
                  ) : (
                    <AngleDoubleRightIcon />
                  )}
                </span>
              </div>
              <div class="div_49_no_overflow p-1">
                <span className="analytics_header analytics-label">
                  Selected Criteria
                </span>
              </div>

              <div class="div_Equal_no_overflow p-1">
                <span className="analytics_header analytics-label">Total</span>
              </div>
            </div>
            {this.props.isServiceInquiryDataFound && (
              <div>
                <div class="div_inline">
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-border">
                      <div class="analytics_select_criteria_panel">
                        <div className="div_inline ">
                          <div className="div_Equal_no_overflow">
                            <Row class="d-flex justify-content-left">
                              <Col sm="4">
                                <FormLabel className="analytics-label pb-1">
                                  Date :
                                </FormLabel>
                              </Col>
                              <Col sm="8">
                                <FormLabel className="analytics-font">
                                  {criteria.dateModeType}
                                </FormLabel>
                              </Col>
                            </Row>
                            {this.props.isShowYearBox ? (
                              <Row class="d-flex justify-content-left">
                                <Col sm="4">
                                  <FormLabel className="analytics-label pb-1">
                                    Year :
                                  </FormLabel>
                                </Col>
                                <Col sm="8">
                                  <FormLabel className="analytics-font">
                                    {criteria.year}
                                  </FormLabel>
                                </Col>
                              </Row>
                            ) : null}
                            {this.props.isShowSpecificDate ? (
                              <>
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    <FormLabel className="analytics-label pb-1">
                                      FromDate :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel>{criteria.startDate}</FormLabel>
                                  </Col>
                                </Row>
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    <FormLabel className="analytics-label pb-1">
                                      ToDate :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel className="analytics-font">
                                      {criteria.stopDate}
                                    </FormLabel>
                                  </Col>
                                </Row>
                              </>
                            ) : null}
                          </div>

                          {!isEmptyString(criteria.customerCode) ||
                          !isEmptyString(criteria.serviceCode) ? (
                            <div class="div_Equal_no_overflow">
                              {!isEmptyString(criteria.customerCode) ? (
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    {" "}
                                    <FormLabel className="analytics-label pb-1">
                                      Customer :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel className="analytics-font">
                                      {criteria.customerCode}
                                    </FormLabel>
                                  </Col>
                                </Row>
                              ) : null}
                              {!isEmptyString(criteria.serviceCode) ? (
                                <Row class="d-flex justify-content-left">
                                  <Col sm="4">
                                    {" "}
                                    <FormLabel className="analytics-label pb-1">
                                      Service :
                                    </FormLabel>
                                  </Col>
                                  <Col sm="8">
                                    <FormLabel className="analytics-font">
                                      {criteria.serviceCode}
                                    </FormLabel>
                                  </Col>
                                </Row>
                              ) : null}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-dashboard-value">
                      <div class="div_inline">
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(
                              this.props.totalInBoundServiceAmount,
                            )}

                            <span>{currencyCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            TotalInboundService(Amount)
                          </h4>
                        </div>
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(
                              this.props.totalOutBoundServiceAmount,
                            )}
                            <span>{currencyCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            TotalOutboundService(Amount)
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="div_inline_justify">
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={inboundServiceList}
                      columns={this.inboundServiceColumns()}
                      label={"Inbound Service Infos"}
                      cstmStyle="custom_style"
                      isShowPagination={true}
                      totalPages={this.props.inBoundServiceTotalPage}
                      currentPage={this.props.inBoundServiceCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadServiceInboundPrevious(e)
                      }
                      loadNext={(e) => this.props.loadServiceInboundNext(e)}
                      handleOnchange={(e) =>
                        this.props.serviceInvoundOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.serviceInboundOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.handleServiceInboundPageClick(e)
                      }
                    />
                  </div>
                  <div className="div_Equal_custom_table">
                    <CustomTable
                      data={outboundServiceList}
                      columns={this.outboundServiceColumns()}
                      label={"Out Service Infos"}
                      cstmStyle="custom_style"
                      isShowPagination={true}
                      totalPages={this.props.outBoundServiceTotalPage}
                      currentPage={this.props.outBoundServiceCurrentPage}
                      loadPrevious={(e) =>
                        this.props.loadServiceOutBoundPrevious(e)
                      }
                      loadNext={(e) => this.props.loadServiceOutBoundNext(e)}
                      handleOnchange={(e) =>
                        this.props.serviceOutBoundOnChange(e)
                      }
                      handlePaginationOnBlur={(e) =>
                        this.props.serviceOutBoundOnBlur(e)
                      }
                      onPageClick={(e) =>
                        this.props.serviceOutBoundPageClick(e)
                      }
                    />
                  </div>

                  <div></div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class InventoryViewForm extends React.Component {
  static contextType = AppContext;

  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const { appData } = this.context;
    this.companyCode = appData.companyCode;
    // this.loadInboundPageList()
    // this.loadOutboundPageList()
  }

  inventoryColumns = () => {
    const columns = new Array();
    columns.push(
      new ColumnDefinition()
        .setDetails("FabricStyle", "fabricStyleCode", true)
        .setStyleDetails("left", "8", "", "wt-6", "wt-6")
        .setClickDetails(true, false, this.props.viewFabricModule, null),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Name", "fabricStyleName", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Color", "fabricStyleColorCode", true)
        .setStyleDetails("left", "4", "", "wt-4", "wt-4"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("SKU#", "skuNumber", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("UOM", "uomCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("OnHandQty", "onHandQuantity", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalOnHandQuantity"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("Cost", "cost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt(Cost)", "purchaseValuationAmount", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalPurchaseValueAmount"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("LandedCost", "landedCost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("NetCost", "extendedLandedCost", true, true)
        .setStyleDetails("right", "", "", "wt-3", "wt-3"),
    );
    columns.push(
      new ColumnDefinition()
        .setDetails("TotalAmt(NetCost)", "totalNetAmountCost", true, true)
        .setStyleDetails("right", "", "", "wt-4", "wt-4")
        .setSubHeaderDetails(true, "totalAmountNetCost"),
    );

    columns.push(
      new ColumnDefinition()
        .setDetails("Location", "locationCode", true)
        .setStyleDetails("left", "", "", "wt-3", "wt-3"),
    );
    return columns;
  };

  render() {
    let inventoryList = [];
    if (!isEmptyArray(this.props.inventoryList))
      inventoryList = this.props.inventoryList;

    let totalQty = 0;
    let totalAmount = null;

    if (!isEmpty(this.props.inventoryResultData)) {
      totalQty = this.props.inventoryResultData.totalOnHandQuantity;
      totalAmount = this.props.inventoryResultData.totalInventoryNetAmountCost;
    }
    let uomCode = "YD";
    if (!isEmpty(ConfigManager.getUomCode()))
      uomCode = ConfigManager.getUomCode();

    let currencyCode = "USD";
    if (!isEmpty(ConfigManager.getCurrencyCode()))
      currencyCode = ConfigManager.getCurrencyCode();

    let criteria = this.props.salesCriteria;
    let isOpenCriteria = this.props.isOpenCriteria;

    let isInventoryInquiryDataFound = this.props.isInventoryInquiryDataFound;
    return (
      <div>
        <div className="div_inline_justify">
          {isOpenCriteria ? (
            <div className="div_14_no_overflow_no_height analytics_sidebar_clr">
              <div className="div_inline_justify">
                <div className="div_50_no_overflow">
                  <div className="analytics-filter">Filter</div>
                </div>
                <div className="div_30_no_overflow">
                  <Button
                    className="header_buttons btn-flx"
                    size="sm"
                    onClick={(e) => this.props.executeInventoryList(e)}
                  >
                    <PlayIcon />
                    {""}EXECUTE
                  </Button>
                </div>
              </div>

              <div class="div_criteria_panel">
                <h4 class="analytics-label  pt-1">Item / Inventory</h4>

                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      FabricStyle
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleCode"
                      onChange={this.props.fabricCodeOnChange}
                      value={criteria.fabricStyleCode}
                      lookupRequired={true}
                      lookupHandler={this.props.fabricLookupHandler}
                      showCriteriaDialog={true}
                      enterKeyEventHandler={
                        this.props.fabricEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.fabricPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteFabricList
                      }
                      showAutoCompleteList={
                        this.props.isShowAutoCompleteFabricList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Name
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      name="fabricStyleName"
                      onChange={this.props.salesOnChange}
                      value={criteria.fabricStyleName}
                      disabled={true}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Color
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      //  ref={colorCodeRef}
                      onChange={this.props.onFabricColourCodeChange}
                      name="colorCode"
                      placeholder="color"
                      value={criteria.colorCode}
                      lookupRequired={this.props.isShowColorLookup}
                      lookupHandler={this.props.colorLookupHandler}
                      enterKeyEventHandler={
                        this.props.fabricColourEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.fabricColourPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteFabricColorList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteFabricColorList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      UOM
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      onChange={this.props.onPopupUomCodeChange}
                      name="uomCode"
                      placeholder="uomcode"
                      value={criteria.uomCode}
                      lookupRequired={true}
                      lookupHandler={this.props.uomsLookupHandler}
                      enterKeyEventHandler={
                        this.props.uomPopupEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.uomPopupPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteUomPopupList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteUOMPopupList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>

                <Row className="d-flex justify-content-left pb-3">
                  <Col sm="12">
                    <FormLabel className="analytics-font analytics_label_color">
                      Location
                    </FormLabel>
                  </Col>
                  <Col sm="12">
                    <InputTextbox
                      onChange={this.props.locationCodeOnChange}
                      name="locationCode"
                      placeholder="location"
                      value={criteria.locationCode}
                      lookupRequired={true}
                      lookupHandler={this.props.warehouseLookupHandler}
                      enterKeyEventHandler={
                        this.props.locationEnterKeyEventHandler
                      }
                      autoCompleteListData={
                        this.props.locationPageListForAutoCompleteList
                      }
                      enableAutoCompleteTextBox={true}
                      displayAutoCompleteList={
                        this.props.displayAutoCompleteLocationList
                      }
                      showAutoCompleteList={
                        this.props.showAutoCompleteLocationList
                      }
                      disabled={this.props.isDisableFields}
                    />
                  </Col>
                </Row>
              </div>

              <div className="analytics-button">
                <Row className="d-flex justify-content-left">
                  <Col sm="6">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.executeInventoryList(e)}
                    >
                      <PlayIcon />
                      {""}EXECUTE
                    </Button>
                  </Col>

                  <Col sm="5">
                    <Button
                      className="header_buttons btn-flx"
                      size="sm"
                      onClick={(e) => this.props.resetInventoryList(e)}
                    >
                      <UndoAlt />
                      {""}RESET
                    </Button>
                  </Col>
                </Row>
              </div>
            </div>
          ) : null}

          <div
            class={
              isOpenCriteria
                ? "div_86_no_overflow_no_height"
                : "div_100_no_overflow"
            }
          >
            {/* <div class="div_70_no_overflow"> */}

            <div class="div_inline">
              <div class="div_sideNav">
                <span onClick={() => this.props.closeNav()}>
                  {isOpenCriteria ? (
                    <AngleDoubleLeftIcon />
                  ) : (
                    <AngleDoubleRightIcon />
                  )}
                </span>
              </div>
              <div class="div_49_no_overflow p-1">
                <span className="analytics_header analytics-label">
                  Selected Criteria
                </span>
              </div>

              <div class="div_Equal_no_overflow p-1">
                <span className="analytics_header analytics-label">Total</span>
              </div>
            </div>
            {this.props.isInventoryInquiryDataFound && (
              <div>
                <div class="div_inline">
                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-border">
                      <div class="analytics_select_criteria_panel">
                        <div className="div_inline">
                          <div className="div_Equal_no_overflow">
                            {!isEmptyString(criteria.fabricStyleCode) ||
                            !isEmptyString(criteria.uomCode) ||
                            !isEmptyString(criteria.locationCode) ? (
                              <div class="">
                                {!isEmptyString(criteria.fabricStyleCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Item :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.fabricStyleCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.uomCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        UOM :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.uomCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}

                                {!isEmptyString(criteria.locationCode) ? (
                                  <Row class="d-flex justify-content-left">
                                    <Col sm="4">
                                      {" "}
                                      <FormLabel className="analytics-label pb-1">
                                        Location :
                                      </FormLabel>
                                    </Col>
                                    <Col sm="8">
                                      <FormLabel className="analytics-font">
                                        {criteria.locationCode}
                                      </FormLabel>
                                    </Col>
                                  </Row>
                                ) : null}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="div_Equal_no_overflow p-1">
                    <div class="analytics-dashboard-value">
                      <div class="div_inline">
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalQty)}

                            <span>{uomCode}</span>
                          </h2>
                          <h4 class="analytics-label">TotalInventory(Qty)</h4>
                        </div>
                        <div className="div_Equal_no_overflow">
                          <h2 class="analytics_Number_align">
                            {toCommaSeperatedAmount(totalAmount)}
                            <span>{currencyCode}</span>
                          </h2>
                          <h4 class="analytics-label">
                            TotalInventory(Amount)
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* <div className="div_inline_justify"> */}
                <div className="div_Custom_2">
                  <CustomTable
                    data={inventoryList}
                    columns={this.inventoryColumns()}
                    label={"Inventory Infos"}
                    cstmStyle="custom_style"
                    isShowPagination={true}
                    enableVritualizer={true}
                    isShowChartButton={true}
                    chartButtonRender={"Chart"}
                    chartButtonClickHandler={(e) =>
                      this.props.inventoryChartHandler(e)
                    }
                  />
                </div>

                <div></div>
                {/* </div> */}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

class ErpIDashBoard extends React.Component {
  constructor(props) {
    super(props);
    this.moduleRef = React.createRef();
  }
  render() {
    return (
      <div id="moduleContainer" className="module_container">
        <div className="App">
          <ErpDashBoardForm {...this.props} name="" ref={this.moduleRef} />{" "}
          <br />
        </div>
      </div>
    );
  }
}

export default ErpIDashBoard;
